webpackJsonp([0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(332);


/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(335);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _common = __webpack_require__(416);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _components = __webpack_require__(474);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _app = __webpack_require__(590);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _services = __webpack_require__(594);
	
	var _services2 = _interopRequireDefault(_services);
	
	__webpack_require__(641);
	
	var _app3 = __webpack_require__(643);
	
	var _app4 = _interopRequireDefault(_app3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('app', [_angularUiRouter2.default, _common2.default, _components2.default, _services2.default]).config(["$locationProvider", function ($locationProvider) {
	  "ngInject";
	  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	  // #how-to-configure-your-server-to-work-with-html5mode
	
	  $locationProvider.html5Mode(true).hashPrefix('!');
	}]).run(_app4.default).component('app', _app2.default);

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navbar = __webpack_require__(417);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _footer = __webpack_require__(458);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _cpwd = __webpack_require__(464);
	
	var _cpwd2 = _interopRequireDefault(_cpwd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonModule = _angular2.default.module('app.common', [_navbar2.default, _footer2.default, _cpwd2.default]).name;
	
	exports.default = commonModule;

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(335);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _navbar = __webpack_require__(418);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarModule = _angular2.default.module('navbar', [_angularUiRouter2.default]).component('navbar', _navbar2.default).name;
	
	exports.default = navbarModule;

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _navbar = __webpack_require__(419);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _navbar3 = __webpack_require__(420);
	
	var _navbar4 = _interopRequireDefault(_navbar3);
	
	__webpack_require__(454);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarComponent = {
	  bindings: {},
	  template: _navbar2.default,
	  controller: _navbar4.default
	};
	
	exports.default = navbarComponent;

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

	module.exports = "<script src=\"assets/js/scripts.bundle.js\"></script>\n\n<div id=\"kt_header\" class=\"header header-fixed\">\n  <!--begin::Container-->\n  <div class=\"container-fluid d-flex align-items-stretch justify-content-between\" style=\"background:#041e47;\">\n    <!--begin::Header Menu Wrapper-->\n    <div class=\"header-menu-wrapper header-menu-wrapper-left\" id=\"kt_header_menu_wrapper\">\n      <!--begin::Header Logo-->\n      <div class=\"header-logo\" ng-if=true>\n        <a ui-sref=\"main.home\">\n          <img style=\"height:30px\" src=\"assets/app/logo-white-small.png\"/>\n        </a>\n        <span id=\"logoText\" style=\"color:white;padding-top:20px\">{{$ctrl.getLogoText()}}</span>\n      </div>\n      <!--end::Header Logo-->\n      <!--begin::Header Menu-->\n      <div id=\"kt_header_menu\" class=\"header-menu header-menu-mobile header-menu-layout-default\">\n        <!--begin::Header Nav-->\n        <ul class=\"menu-nav\">\n          <li class=\"menu-item menu-item-submenu menu-item-rel \" data-menu-toggle=\"hover\" aria-haspopup=\"true\"\n            ng-repeat=\"item in $ctrl.getNavbarItems()\">\n            <a href=\"javascript:;\" ui-sref=\"{{item.itemLink}}\" ui-sref-opts=\"{reload: true, notify: true}\" class=\"menu-link menu-toggle font-weight-bold mr-2\">\n              <!-- <span class=\"menu-text px-2\"><i class=\"fas {{item.itemIcon}} clr-in\"></i></span>  -->\n              <span class=\"menu-text\">{{item.itemText}}</span>\n            </a>\n            <div class=\"menu-submenu menu-submenu-classic menu-submenu-left\" ng-if=item.subItems !=undefined>\n              <ul class=\"menu-subnav\">\n                <li class=\"menu-item menu-item-submenu  menu-item-rel\" data-menu-toggle=\"hover\" aria-haspopup=\"true\"\n                  ng-repeat=\"subItem in item.subItems\">\n                  <a href=\"javascript:;\" ui-sref=\"{{subItem.itemLink}}\" ui-sref-opts=\"{reload: true, notify: true}\" class=\"menu-link\">\n                    <span class=\"menu-text\">{{subItem.itemText}}</span>\n                    <i ng-if=subItem.subItems !=undefined class=\"menu-arrow\"></i>\n                  </a>\n                  <div class=\"menu-submenu menu-submenu-classic menu-submenu-right\" ng-if=subItem.subItems !=undefined>\n                    <ul class=\"menu-subnav\">\n                      <li class=\"menu-item\" aria-haspopup=\"true\" ng-repeat=\"subsubItem in subItem.subItems\">\n                        <a href=\"javascript:;\" ui-sref=\"{{subsubItem.itemLink}}\" ui-sref-opts=\"{reload: true, notify: true}\" class=\"menu-link\">\n                          <span class=\"menu-text\">{{subsubItem.itemText}}</span>\n                        </a>\n                      </li>\n                    </ul>\n                  </div>\n                </li>\n              </ul>\n            </div>\n          </li>\n        </ul>\n        <!--end::Header Nav-->\n      </div>\n      <!--end::Header Menu-->\n    </div>\n    <!--end::Header Menu Wrapper-->\n    <!--begin::Topbar-->\n    <div class=\"topbar\">\n      <div class=\"topbar-item\">\n        <div>\n          <span class=\"font-weight-bolder font-size-base d-none d-md-inline mr-3 text-white\" id=\"navbar-first-name\"></span>\n        </div>\n      </div>\n      <ul class=\"nav nav-bold nav-tabs-line\">\n        <li class=\"nav-item dropdown\">\n          <a class=\"\" data-toggle=\"dropdown\" data-menu-toggle=\"hover\" href=\"javascript:;\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">\n            <div class=\"btn btn-icon btn-lg btn-dropdown\">\n              <div class=\"btn-icon w-auto d-flex align-items-center btn-lg px-2\" id=\"kt_quick_user_toggle1\">\n                <span class=\"symbol symbol-35 symbol-light-success\">\n                    <span class=\"symbol-label font-size-h5 font-weight-bold\" id=\"navbar-first-name-letter\"></span>\n                </span>\n              </div>\n            </div>\n          </a>\n          <div class=\"dropdown-menu dropdown-menu-sm dropdown-menu-right\" >\n            <button class=\"dropdown-item\"  ng-click=$ctrl.editProfile()>Edit Profile</button>\n            <button class=\"dropdown-item\"  ng-click=$ctrl.changePassword()>Change Password</button>\n            <button class=\"dropdown-item\"  ng-click=$ctrl.logout()>Logout</button>\n          </div>\n        </li>\n      </ul>\n    </div>\n    <!--end::Topbar-->\n  </div>\n  <!--end::Container-->\n</div>\n"

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(421);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(425);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _navbarItems = __webpack_require__(444);
	
	var _navbarItems2 = _interopRequireDefault(_navbarItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarController = function () {
	  NavbarController.$inject = ["AuthService", "ClientService", "$state"];
	  function NavbarController(AuthService, ClientService, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, NavbarController);
	    this.name = 'navbar';
	    this.authService = AuthService;
	    this.clientService = ClientService;
	    this.state = $state;
	    this.displayNavbarItems = [];
	    this.navbarItems = this.deepCopyObject(_navbarItems2.default);
	  }
	
	  (0, _createClass3.default)(NavbarController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var userRoles = this.authService.getUserRoles();
	
	      var cachedNavbarItems = sessionStorage.getItem("userNavbarItems");
	
	      if (cachedNavbarItems) {
	        //console.log("Showing cached nav")
	        this.displayNavbarItems = JSON.parse(cachedNavbarItems);
	      } else {
	        //console.log("Showing new nav")
	        this.displayNavbarItems = this.filterNavbarItems(this.navbarItems, userRoles);
	        sessionStorage.setItem("userNavbarItems", (0, _stringify2.default)(this.displayNavbarItems));
	      }
	
	      //Get the user data from the auth service
	      var firstName = this.authService.getUserFirstName();
	      $('#navbar-first-name').html(firstName);
	      $('#navbar-first-name-letter').html(firstName && firstName.charAt(0));
	    }
	  }, {
	    key: 'getLogoText',
	    value: function getLogoText() {
	      if (window.location.hostname.startsWith("demo.")) {
	        return 'DEMO';
	      }
	
	      return '';
	    }
	  }, {
	    key: 'getNavbarItems',
	    value: function getNavbarItems() {
	      return this.displayNavbarItems;
	    }
	  }, {
	    key: 'filterNavbarItems',
	    value: function filterNavbarItems(navbarItems, userRoles) {
	      var _this = this;
	
	      if (navbarItems === undefined) return undefined;
	      var filteredNavbarItems = navbarItems.filter(function (element) {
	        var userHasRequiredRole = false;
	        element.rolesRequired.forEach(function (role) {
	          if (userRoles.find(function (x) {
	            return x === role;
	          })) {
	            userHasRequiredRole = true;
	          }
	        });
	        return userHasRequiredRole;
	      });
	
	      filteredNavbarItems.forEach(function (navbarItem) {
	        navbarItem.subItems = _this.filterNavbarItems(navbarItem.subItems, userRoles);
	      });
	
	      return filteredNavbarItems;
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      this.authService.logout();
	    }
	  }, {
	    key: 'changePassword',
	    value: function changePassword() {
	      this.state.go("main.resetPassword");
	    }
	  }, {
	    key: 'editProfile',
	    value: function editProfile() {
	      this.state.go("main.editProfile");
	    }
	  }, {
	    key: 'deepCopyObject',
	    value: function deepCopyObject(object) {
	      return JSON.parse((0, _stringify2.default)(object));
	    }
	  }]);
	  return NavbarController;
	}();
	
	exports.default = NavbarController;

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _freeze = __webpack_require__(445);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _navbarItem = __webpack_require__(451);
	
	var _navbarItem2 = _interopRequireDefault(_navbarItem);
	
	var _accessRules = __webpack_require__(452);
	
	var _accessRules2 = _interopRequireDefault(_accessRules);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = (0, _freeze2.default)([new _navbarItem2.default("User Maintenance", "main.user", null, _accessRules2.default.USER_MAINTENANCE)]);

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarItem = function NavbarItem(itemText, itemLink, itemIcon, rolesRequired, subItems) {
	    (0, _classCallCheck3.default)(this, NavbarItem);
	
	    this.itemText = itemText;
	    this.itemLink = itemLink;
	    this.itemIcon = itemIcon;
	    this.rolesRequired = rolesRequired;
	    this.subItems = subItems;
	};
	
	exports.default = NavbarItem;

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _freeze = __webpack_require__(445);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _userRoles = __webpack_require__(453);
	
	var _userRoles2 = _interopRequireDefault(_userRoles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = (0, _freeze2.default)({
	    USER_MAINTENANCE: [_userRoles2.default.PORTAL_ADMIN]
	});

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _freeze = __webpack_require__(445);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = (0, _freeze2.default)({
	    PORTAL_ADMIN: 1,
	    PORTAL_USER: 2,
	
	    REF_SUPER_ADMIN: 100,
	    REF_ADMIN: 101,
	    REF_DATA_ENTRY: 102,
	
	    TD_SUPER_ADMIN: 200,
	    //User Permissions are required for all below roles
	    TD_ADMIN: 201,
	    TD_TAKEDOWN_ADMIN: 202,
	    TD_BUILDER: 203,
	    TD_ASSET_MANAGER: 204,
	    TD_READ_ONLY: 205
	});

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(455);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(457)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./navbar.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./navbar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(456)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:62.5% Roboto,sans-serif}.filter-option *{color:#464e5f}.subheader{color:#041e47;justify-content:center;font-size:14pt}.navbar{height:6.5rem;background-color:#041e47;padding:1rem}.navbar .logo,.navbar .nav-links{display:inline-block}.navbar .logo{color:#f5f5f5;margin-right:50%}.navbar .nav-links span{color:#f5f5f5;font-size:1.6rem}.clr-in{color:inherit}.menu-nav>.menu-item:after{content:\"|\";float:right;color:#fff}.menu-nav>.menu-item:last-child:after{display:none}.symbol.symbol-light-success .symbol-label{background-color:#beebff;color:#041e47}.link-button{background:none!important;border:none;padding:0}.navHighlight{font-weight:700!important;color:#beebff!important;font-size:1.2em!important}", ""]);
	
	// exports


/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(335);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _footer = __webpack_require__(459);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var footerModule = _angular2.default.module('footer', [_angularUiRouter2.default]).component('footer', _footer2.default).name;
	
	exports.default = footerModule;

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _footer = __webpack_require__(460);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _footer3 = __webpack_require__(461);
	
	var _footer4 = _interopRequireDefault(_footer3);
	
	__webpack_require__(462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var footerComponent = {
	  bindings: {},
	  template: _footer2.default,
	  controller: _footer4.default
	};
	
	exports.default = footerComponent;

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

	module.exports = "<!--begin::Footer-->\n<div class=\"footer bg-white py-4 d-flex flex-lg-column\" id=\"kt_footer\">\n  <!--begin::Copyright-->\n  <div class=\"text-dark order-2 order-md-1 d-flex justify-content-end\">\n    <span class=\"font-weight-bold mr-2\">{{$ctrl.currentYear}}©</span>\n    <span class=\"pr-10\">HSS</span>\n  </div>\n  <!--end::Copyright-->\n</div>\n<!--end::Footer-->\n"

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterController = function FooterController() {
	  (0, _classCallCheck3.default)(this, FooterController);
	
	  this.name = 'footer';
	  this.currentYear = new Date().getFullYear();
	};
	
	exports.default = FooterController;

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(463);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(457)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./footer.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./footer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(456)();
	// imports
	
	
	// module
	exports.push([module.id, ".footer{color:red}", ""]);
	
	// exports


/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(335);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _cpwd = __webpack_require__(465);
	
	var _cpwd2 = _interopRequireDefault(_cpwd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cpwdModule = _angular2.default.module('cpwd', [_angularUiRouter2.default]).component('cpwd', _cpwd2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('cpwd', {
	    name: 'cpwd',
	    url: '',
	    component: 'cpwd',
	    params: { id: undefined }
	  });
	}]).name;
	
	exports.default = cpwdModule;

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cpwd = __webpack_require__(466);
	
	var _cpwd2 = _interopRequireDefault(_cpwd);
	
	var _cpwd3 = __webpack_require__(467);
	
	var _cpwd4 = _interopRequireDefault(_cpwd3);
	
	__webpack_require__(472);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cpwdComponent = {
	  bindings: {},
	  template: _cpwd2.default,
	  controller: _cpwd4.default
	};
	
	exports.default = cpwdComponent;

/***/ }),

/***/ 466:
/***/ (function(module, exports) {

	module.exports = "<div class=\"d-flex flex-column-fluid mt-40 justify-content-center\">\n  <!--begin::ChangePassword-->\n  <div class=\"flex-center card card-custom px-20 py-5 cpwd-form \">\n    <div class=\"mb-10\">\n      <div class=\"font-size-h1\">Change Password</div>\n      <p class=\"font-weight-bold text-center\">Enter your new password</p>\n    </div>\n    <!--begin::Form-->\n    <form class=\"form\" novalidate=\"novalidate\" id=\"kt_login_forgot_form\">\n      <div class=\"form-group\">\n        <label for=\"m_password\">Password</label>\n        <input class=\"form-control form-control-solid\" type=\"password\"\n          name=\"password\" autocomplete=\"off\" id=\"m_password\" />\n      </div>\n      <div class=\"form-group\">\n        <label for=\"m_repassword\">Confirm Password</label>\n        <input class=\"form-control form-control-solid\" type=\"password\"\n          name=\"password\" autocomplete=\"off\" id=\"m_repassword\" />\n      </div>\n      <ul style=\"opacity:0.8\">\n        <li>Password must be at least 8 characters</li>\n        <li>Password cannot contain common words</li>\n        <li>Password cannot contain 3 or more duplicate or sequential characters (e.g. rrr, 123, abc)</li>\n      </ul>\n      <div class=\"form-group d-flex flex-wrap flex-center\">\n        <button type=\"submit\" id=\"kt_login_forgot_submit\" class=\"w-75 btn btn-primary font-weight-bold\"\n          ng-click=$ctrl.resetPassword()>Submit</button>\n      </div>\n    </form>\n    <!--end::Form-->\n  </div>\n  <!--end::ChangePassword-->\n</div>\n"

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(425);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _dialogUtil = __webpack_require__(468);
	
	var _dialogUtil2 = _interopRequireDefault(_dialogUtil);
	
	var _apiStatus = __webpack_require__(471);
	
	var _apiStatus2 = _interopRequireDefault(_apiStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CpwdController = function () {
	  CpwdController.$inject = ["$stateParams", "$state", "AuthService"];
	  function CpwdController($stateParams, $state, AuthService) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, CpwdController);
	    this.name = 'changePassword';
	    this.token = $stateParams.id; //This would be null if changing on the site; set if from email link
	    this.authService = AuthService;
	    this.state = $state;
	    this.currentYear = new Date().getFullYear();
	    //If coming from email reset, go to login; otherwise main page
	    this.redirect = this.token ? "auth.login" : "main.home";
	  }
	
	  (0, _createClass3.default)(CpwdController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword() {
	      var _this = this;
	
	      var password = $("#m_password").val();
	      var rePassword = $("#m_repassword").val();
	
	      if (this.validate(password, rePassword)) {
	        // If id is passed it, then coming from external link from email. So set session
	        this.authService.resetPassword(this.token, password, function (result) {
	          if (result.apiStatus === _apiStatus2.default.SUCCESS) {
	            _this.redirectToPage();
	            _dialogUtil2.default.showSuccessMessage("Your password has been changed. Please use the new password on your next login!");
	          } else if (result.apiStatus === _apiStatus2.default.INVALID_CHANGE_PASSWORD_SESSION) {
	            _dialogUtil2.default.showErrorMessage("Your password reset link has expired.  You can request another link by using Forgot Password");
	          } else if (result.apiStatus === _apiStatus2.default.INVALID_PASSWORD_TOO_SHORT) {
	            _dialogUtil2.default.showErrorMessage("Your password is too short");
	          } else if (result.apiStatus === _apiStatus2.default.INVALID_PASSWORD_COMMON_WORD) {
	            _dialogUtil2.default.showErrorMessage("Your password contains a common word");
	          } else if (result.apiStatus === _apiStatus2.default.INVALID_PASSWORD_DUP_OR_SEQ) {
	            _dialogUtil2.default.showErrorMessage("Your password contains 3 or more duplicate or sequential characters");
	          } else {
	            _dialogUtil2.default.showErrorMessage("Something went wrong!");
	          }
	        });
	      }
	    }
	  }, {
	    key: 'validate',
	    value: function validate(password, rePassword) {
	      var isValid = true;
	      if (password.length < 8) {
	        _dialogUtil2.default.showErrorMessage("Password should have a minimum of eight characters!");
	        isValid = false;
	      } else if (password !== rePassword) {
	        _dialogUtil2.default.showErrorMessage("Passwords do not match!");
	        isValid = false;
	      }
	
	      return isValid;
	    }
	  }, {
	    key: 'redirectToPage',
	    value: function redirectToPage() {
	      this.state.go(this.redirect);
	    }
	  }]);
	  return CpwdController;
	}();
	
	exports.default = CpwdController;

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _sweetalert = __webpack_require__(469);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _formatUtil = __webpack_require__(470);
	
	var _formatUtil2 = _interopRequireDefault(_formatUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.showErrorMessage = function (errorMessage, callback) {
	    _sweetalert2.default.fire({
	        icon: 'error',
	        title: 'Error',
	        text: errorMessage
	    }).then(function () {
	        if (callback) callback();
	    });
	};
	
	exports.showErrorMessageHtml = function (errorMessage, callback) {
	    _sweetalert2.default.fire({
	        icon: 'error',
	        title: 'Error',
	        html: errorMessage
	    }).then(function () {
	        if (callback) callback();
	    });
	};
	
	exports.showSuccessMessage = function (successMessage, callback) {
	    _sweetalert2.default.fire({
	        icon: 'success',
	        title: 'Success',
	        text: successMessage
	    }).then(function () {
	        if (callback) callback();
	    });
	};
	
	exports.showAlertMessageHtml = function (alertMessage, callback) {
	    _sweetalert2.default.fire({
	        html: alertMessage
	    }).then(function () {
	        if (callback) callback();
	    });
	};
	
	exports.showUser = function (userMap, callback) {
	    var workPhone = _formatUtil2.default.formatPhone(userMap.workPhone, false);
	    var cellPhone = _formatUtil2.default.formatPhone(userMap.cellPhone, true);
	    var detail = '<table class="userDetailPopup" style="width: 100%">' + '<tr><td>Name:</td><td>' + userMap.fullName + '</td></tr>' + '<tr><td>Title:</td><td>' + userMap.title + '</td></tr>' + '<tr><td>Email:</td><td>' + userMap.username + '</td></tr>' + '<tr><td>Work Phone:</td><td>' + workPhone + '</td></tr>' + '<tr><td>Cell Phone:</td><td>' + cellPhone + '</td></tr>' + '<tr><td>Address:</td><td>' + userMap.address + '</td></tr>' + '</table>';
	    _sweetalert2.default.fire({
	        title: 'User Detail',
	        width: '600px',
	        html: detail
	    }).then(function () {
	        if (callback) callback();
	    });
	};
	
	exports.confirm = function (confirmQuestion, callbackIfConfirmed) {
	    _sweetalert2.default.fire({
	        title: 'Are you sure?',
	        text: confirmQuestion,
	        showCancelButton: true
	        //confirmButtonColor: '#3085d6',
	        //cancelButtonColor: '#d33',
	        //confirmButtonText: 'Yes, delete it!'
	    }).then(function (result) {
	        if (result.isConfirmed) {
	            callbackIfConfirmed();
	        }
	    });
	};

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

	'use strict';
	
	exports.formatPhone = function (phone, strict) {
	  //first just read any numbers and remove any non digits until I get at least 10 digits
	  var tmp = "";
	
	  var i;
	  for (i = 0; i < phone.length; i++) {
	    var ch = phone.charAt(i);
	    if (tmp.length >= 10 && ch == ' ') {
	      tmp += phone.substring(i);
	      break;
	    }
	
	    if (ch >= '0' && ch <= '9') {
	      tmp += ch;
	    }
	  }
	
	  if (tmp.length < 10) {
	    return;
	  }
	
	  if (strict && tmp.length > 10) {
	    return;
	  }
	
	  //now insert the hyphens at the proper place
	  var formatted = tmp.substring(0, 3) + "-" + tmp.substring(3, 6) + "-" + tmp.substring(6);
	  //elem.val(formatted);  //show formatted value on the screen
	
	  return formatted;
	};

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _freeze = __webpack_require__(445);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = (0, _freeze2.default)({
	    SUCCESS: "SUCCESS",
	    //NOT_FOUND: "NOT_FOUND",
	    UNAUTHORIZED: "UNAUTHORIZED",
	    INVALID_SESSION: "INVALID_SESSION",
	    USER_LOCKED: "USER_LOCKED",
	    INVALID_CHANGE_PASSWORD_SESSION: "INVALID_CHANGE_PASSWORD_SESSION",
	    ALREADY_EXISTS: "ALREADY_EXISTS",
	    //BUSINESS_RULE_FAILED: "BUSINESS_RULE_FAILED",
	    //DATA_STORAGE_ERROR: "DATA_STORAGE_ERROR",
	    INVALID_PASSWORD_TOO_SHORT: "INVALID_PASSWORD_TOO_SHORT",
	    INVALID_PASSWORD_COMMON_WORD: "INVALID_PASSWORD_COMMON_WORD",
	    INVALID_PASSWORD_DUP_OR_SEQ: "INVALID_PASSWORD_DUP_OR_SEQ"
	});

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(473);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(457)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./cpwd.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./cpwd.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(456)();
	// imports
	
	
	// module
	exports.push([module.id, "cpwd .cpwd-form{padding:20px 50px;max-width:500px}", ""]);
	
	// exports


/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _home = __webpack_require__(475);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _login = __webpack_require__(481);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _changePassword = __webpack_require__(488);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	var _main = __webpack_require__(494);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _resetPassword = __webpack_require__(500);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _auth = __webpack_require__(506);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _editProfile = __webpack_require__(512);
	
	var _editProfile2 = _interopRequireDefault(_editProfile);
	
	var _user = __webpack_require__(519);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentModule = _angular2.default.module('app.components', [
	//These two are needed for the app to work.
	_main2.default, _auth2.default, _editProfile2.default, _home2.default, _login2.default, _changePassword2.default, _resetPassword2.default, _user2.default]).name;
	
	exports.default = componentModule;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(335);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _home = __webpack_require__(476);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homeModule = _angular2.default.module('home', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/');
	
	  $stateProvider.state('main.home', {
	    name: "main.home",
	    url: '/',
	    component: 'home',
	    data: { protected: true }
	  });
	}]).component('home', _home2.default).name;
	
	exports.default = homeModule;

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _home = __webpack_require__(477);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _home3 = __webpack_require__(478);
	
	var _home4 = _interopRequireDefault(_home3);
	
	__webpack_require__(479);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homeComponent = {
	  bindings: {},
	  template: _home2.default,
	  controller: _home4.default
	};
	
	exports.default = homeComponent;

/***/ }),

/***/ 477:
/***/ (function(module, exports) {

	module.exports = "<div class=\"homePage\">\n  <div class=\"d-flex flex-column flex-row-fluid\" style=\"padding-top:125px;align-items: center\">\n    <div class=\"card card-custom align-items-center justify-content-center\">\n      <div class=\"mainPage\">\n        <h2 class=\"font-weight-boldest\">Select the system you'd like to access</h2>\n        <hr/>\n        <div id=\"appContainerWrapper\">\n          <div ng-if=\"$ctrl.applications.length<1\">You do not have access to any system.  Please contact an administrator for access.</div>\n          <div id=\"appContainer\" class=\"d-inline-flex justify-content-center\">\n            <div ng-repeat=\"app in $ctrl.applications\" >\n              <div ng-if=\"app.enabled\" class=\"appItem d-flex align-items-center justify-content-center cursor-pointer\" ng-click=\"$ctrl.goToApp(app.url)\">\n                {{app.name}}\n              </div>\n              <div ng-if=\"!app.enabled\" class=\"appItem d-flex align-items-center justify-content-center appDisabled\">\n                {{app.name}}\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(425);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeController = function () {
	  HomeController.$inject = ["ClientService", "AuthService", "$scope", "$state"];
	  function HomeController(ClientService, AuthService, $scope, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, HomeController);
	    this.name = 'home';
	    this.clientService = ClientService;
	    this.authService = AuthService;
	    this.scope = $scope;
	    this.state = $state;
	    this.applications = [];
	  }
	
	  (0, _createClass3.default)(HomeController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      //Hdd to do this here since webpack was giving me an issue in css
	      $('.app').css('background-image', 'url("assets/app/lot_bg.png")').css('background-repeat', 'no-repeat').css('background-size', 'cover').css('background-position', 'center');
	
	      $('.footer').removeClass('bg-white'); //so the image expands full screen
	
	      this.applications = this.authService.getAppAccess();
	    }
	  }, {
	    key: 'goToApp',
	    value: function goToApp(url) {
	      window.location = url;
	    }
	  }]);
	  return HomeController;
	}();
	
	exports.default = HomeController;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(480);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(457)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./home.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./home.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(456)();
	// imports
	
	
	// module
	exports.push([module.id, ".homePage .card{background-color:hsla(0,0%,100%,.9);max-width:90%;width:90%;font-size:1.5em;padding:50px}.homePage .mainPage{width:100%;text-align:center;padding-bottom:100px;overflow:hidden}.homePage #appContainerWrapper{overflow:auto;margin-top:50px}.homePage .appItem{background:#041e47;border-radius:1rem;width:200px;height:200px;color:#fff;font-size:24px;margin:0 30px;padding:10px}.homePage .appDisabled{background:#d3d3d3}", ""]);
	
	// exports


/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(335);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _login = __webpack_require__(482);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginModule = _angular2.default.module('login', [_angularUiRouter2.default]).component('login', _login2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('auth.login', {
	    name: 'auth.login',
	    url: '/login',
	    component: 'login'
	  });
	}]).name;
	
	exports.default = loginModule;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _login = __webpack_require__(483);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _login3 = __webpack_require__(484);
	
	var _login4 = _interopRequireDefault(_login3);
	
	__webpack_require__(486);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginComponent = {
	  bindings: {},
	  template: _login2.default,
	  controller: _login4.default
	};
	
	exports.default = loginComponent;

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

	module.exports = "<div class=\"d-flex flex-column-fluid flex-center mt-30 mt-lg-0\" style=\"height:100vh\">\n  <!--begin::Signin-->\n  <div class=\"login-form login-signin\">\n    <div class=\"text-left mb-10 mb-lg-20\">\n      <h3 class=\"font-size-h1\">Login to your HSS account</h3>\n      <p class=\"font-weight-bold\">Enter your information below</p>\n    </div>\n    <!--begin::Form-->\n    <form class=\"form\" novalidate=\"novalidate\" id=\"kt_login_signin_form\">\n      <div class=\"form-group\">\n        <label for=\"m_username\">Email</label>\n        <input class=\"form-control form-control-solid h-auto py-5 px-6\" type=\"text\" name=\"username\" autocomplete=\"off\" id=\"m_username\"/>\n      </div>\n      <div class=\"form-group\">\n        <div class=\"d-flex justify-content-between\">\n          <label for=\"m_password\">Password</label>\n          <a href=\"javascript:\" class=\"text-dark-75 text-hover-primary\" id=\"kt_login_forgot\">Forgot Password ?</a>\n        </div>\n        <input class=\"form-control form-control-solid h-auto py-5 px-6\" type=\"password\" name=\"password\" autocomplete=\"off\" id=\"m_password\"/>\n      </div>\n      <!--begin::Action-->\n      <div class=\"form-group d-flex flex-wrap justify-content-between align-items-center\">\n<!--        <a href=\"javascript:;\" class=\"text-dark-50 text-hover-primary my-3 mr-2\" id=\"kt_login_forgot\">Forgot Password ?</a>-->\n        <button type=\"submit\" id=\"kt_login_signin_submit\" class=\"w-100 btn btn-primary font-weight-bold px-9 py-4 my-3\" ng-click=$ctrl.logIn()>Sign In</button>\n      </div>\n      <!--end::Action-->\n    </form>\n    <!--end::Form-->\n  </div>\n  <!--end::Signin-->\n  <!--begin::Forgot-->\n  <div class=\"login-form login-forgot\">\n    <div class=\"text-left mb-10 mb-lg-20\">\n      <h3 class=\"font-size-h1\">Forgot Your Password?</h3>\n      <p class=\"font-weight-bold\">Enter your email to reset your password</p>\n    </div>\n    <!--begin::Form-->\n    <form class=\"form\" novalidate=\"novalidate\" id=\"kt_login_forgot_form\">\n      <div class=\"form-group\">\n        <label for=\"reset_pwd_email\">Email</label>\n        <input id=\"reset_pwd_email\" class=\"form-control form-control-solid h-auto py-5 px-6\" type=\"email\" name=\"email\" autocomplete=\"off\" />\n      </div>\n      <div class=\"form-group d-flex flex-wrap flex-center\">\n        <button type=\"submit\" id=\"kt_login_forgot_submit\" class=\"btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4\" ng-click=\"$ctrl.forgotPassword()\">Submit</button>\n        <button type=\"button\" id=\"kt_login_forgot_cancel\" class=\"btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4\">Cancel</button>\n      </div>\n    </form>\n    <!--end::Form-->\n  </div>\n  <!--end::Forgot-->\n</div>\n"

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(425);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jquery = __webpack_require__(485);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _apiStatus = __webpack_require__(471);
	
	var _apiStatus2 = _interopRequireDefault(_apiStatus);
	
	var _dialogUtil = __webpack_require__(468);
	
	var _dialogUtil2 = _interopRequireDefault(_dialogUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginController = function () {
	  LoginController.$inject = ["AuthService", "ClientService", "$state"];
	  function LoginController(AuthService, ClientService, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, LoginController);
	    this.name = 'login';
	    this.currentYear = new Date().getFullYear();
	    this.state = $state;
	    this.clientService = ClientService;
	    this.authService = AuthService;
	  }
	
	  (0, _createClass3.default)(LoginController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      //transitioning to login page, so remove all session data for current user
	      sessionStorage.clear();
	    }
	  }, {
	    key: 'logIn',
	    value: function logIn() {
	      var _this = this;
	
	      var username = (0, _jquery2.default)("#m_username").val();
	      var password = (0, _jquery2.default)("#m_password").val();
	
	      if (username === '' || password === '') {
	        _dialogUtil2.default.showErrorMessage("Please enter valid inputs");
	      } else {
	        this.authService.login(username, password, function (result) {
	          if (result.apiStatus === _apiStatus2.default.SUCCESS) {
	            _this.state.go("main.home"); //Just go home, the transition auth logic will call to get the user data needed
	          } else if (result.apiStatus === _apiStatus2.default.USER_LOCKED) {
	            _dialogUtil2.default.showErrorMessage("Account locked due to invalid credentials. Please wait 15 minutes and try again.");
	          } else {
	            _dialogUtil2.default.showErrorMessage("The email/password entered is wrong. Please try again.");
	          }
	        });
	      }
	    }
	
	    // getUserApplications() {
	    //   this.authService.getSessionInfo((result) => {
	    //     if (result.apiStatus !== apiStatus.SUCCESS) {
	    //       dialogUtil.showErrorMessage("Error getting user application information")
	    //     } else if(result.data.redirectUrl === undefined) {
	    //       //didnt get redirected, just have data, so go home
	    //       this.state.go("main.home");
	    //     }
	    //   });
	    // }
	
	  }, {
	    key: 'forgotPassword',
	    value: function forgotPassword() {
	      var _this2 = this;
	
	      var email = (0, _jquery2.default)("#reset_pwd_email").val();
	      if (email === '') {
	        _dialogUtil2.default.showErrorMessage("Please enter valid inputs");
	      } else {
	        this.authService.forgotPassword(email, function (result) {
	          if (result.apiStatus === _apiStatus2.default.SUCCESS) {
	            _dialogUtil2.default.showSuccessMessage("Request is being processed. An email link with instructions will be sent when approved.");
	            _this2._showForm("signin");
	          } else {
	            _dialogUtil2.default.showErrorMessage("Something went wrong. Please try again.");
	          }
	        });
	      }
	    }
	  }, {
	    key: '_showForm',
	    value: function _showForm(form) {
	      var cls = 'login-' + form + '-on';
	      var _login = (0, _jquery2.default)('#kt_login');
	
	      _login.removeClass('login-forgot-on');
	      _login.removeClass('login-signin-on');
	      _login.removeClass('login-signup-on');
	
	      _login.addClass(cls);
	    }
	  }]);
	  return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(487);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(457)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./login.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./login.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(456)();
	// imports
	
	
	// module
	exports.push([module.id, ".login{height:100vh}.login #kt_login_forgot_form button{width:40%}.login.login-3 .login-forgot,.login.login-3 .login-signin,.login.login-3 .login-signup,.login.login-3.login-signin-on .login-signup{display:none}.login.login-3.login-signin-on .login-signin{display:block}.login.login-3.login-signin-on .login-forgot{display:none}.login.login-3.login-signup-on .login-signup{display:block}.login.login-3.login-forgot-on .login-signin,.login.login-3.login-forgot-on .login-signup,.login.login-3.login-signup-on .login-forgot,.login.login-3.login-signup-on .login-signin{display:none}.login.login-3.login-forgot-on .login-forgot{display:block}@media (min-width:992px){.login.login-3 .login-aside{width:100%;max-width:1000px}.login.login-3 .login-form{width:100%;max-width:450px}}@media (min-width:992px) and (max-width:1399.98px){.login.login-3 .login-aside{width:100%;max-width:450px}}@media (max-width:991.98px){.login.login-3 .login-form{width:100%;max-width:400px}}@media (max-width:575.98px){.login.login-3 .login-form{width:100%;max-width:100%}}", ""]);
	
	// exports


/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(335);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _changePassword = __webpack_require__(489);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var changePasswordModule = _angular2.default.module('changePassword', [_angularUiRouter2.default]).component('changePassword', _changePassword2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('auth.changePassword', {
	    url: '/changePassword?id',
	    component: 'changePassword',
	    name: 'auth.changePassword',
	    params: { redirect: null }
	  });
	}]).name;
	
	exports.default = changePasswordModule;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _changePassword = __webpack_require__(490);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	var _changePassword3 = __webpack_require__(491);
	
	var _changePassword4 = _interopRequireDefault(_changePassword3);
	
	__webpack_require__(492);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var changePasswordComponent = {
	  bindings: {},
	  template: _changePassword2.default,
	  controller: _changePassword4.default
	};
	
	exports.default = changePasswordComponent;

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

	module.exports = "<cpwd></cpwd>\n"

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shell controller for change password from login. Use it for any login specific functionality
	 */
	var ChangePasswordController = function ChangePasswordController() {
	  (0, _classCallCheck3.default)(this, ChangePasswordController);
	};
	
	exports.default = ChangePasswordController;

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(493);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(457)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./changePassword.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./changePassword.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(456)();
	// imports
	
	
	// module
	exports.push([module.id, ".changePassword{color:red}", ""]);
	
	// exports


/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(335);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _main = __webpack_require__(495);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mainModule = _angular2.default.module('main', [_angularUiRouter2.default]).component('main', _main2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  //$urlRouterProvider.otherwise('/');
	
	  $stateProvider.state('main', {
	    url: '',
	    component: 'main',
	    data: { protected: true }
	  });
	}]).name;
	
	exports.default = mainModule;

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _main = __webpack_require__(496);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _main3 = __webpack_require__(497);
	
	var _main4 = _interopRequireDefault(_main3);
	
	__webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mainComponent = {
	  bindings: {},
	  template: _main2.default,
	  controller: _main4.default
	};
	
	exports.default = mainComponent;

/***/ }),

/***/ 496:
/***/ (function(module, exports) {

	module.exports = "<div id=\"kt_header\" class=\"header header-fixed\">\n  <navbar></navbar>\n</div>\n<div id=\"kt_body\"\n\tclass=\"header-fixed header-mobile-fixed subheader-enabled subheader-fixed aside-enabled aside-fixed aside-minimize-hoverable page-loading\">\n  <!--begin::Main-->\n\t<div class=\"d-flex flex-column flex-root\" style=\"min-height: 96vh;\">\n    <!--begin::Page-->\n    <div ui-view style=\"overflow-y: auto; min-height: 96vh;\"></div>\n    <!--end::Page-->\n    <footer></footer>\n\t</div>\n  <!--end::Main-->\n</div>\n"

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainController = function MainController() {
	  (0, _classCallCheck3.default)(this, MainController);
	
	  this.name = 'main';
	};
	
	exports.default = MainController;

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(499);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(457)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./main.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./main.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(456)();
	// imports
	
	
	// module
	exports.push([module.id, "#kt_wrapper{background-color:#fff!important}", ""]);
	
	// exports


/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(335);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _resetPassword = __webpack_require__(501);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resetPasswordModule = _angular2.default.module('resetPassword', [_angularUiRouter2.default]).component('resetPassword', _resetPassword2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/');
	
	  $stateProvider.state('main.resetPassword', {
	    url: '/resetPassword',
	    name: 'main.resetPassword',
	    component: 'resetPassword',
	    params: { redirect: null }
	  });
	}]).name;
	
	exports.default = resetPasswordModule;

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _resetPassword = __webpack_require__(502);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _resetPassword3 = __webpack_require__(503);
	
	var _resetPassword4 = _interopRequireDefault(_resetPassword3);
	
	__webpack_require__(504);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resetPasswordComponent = {
	  bindings: {},
	  template: _resetPassword2.default,
	  controller: _resetPassword4.default
	};
	
	exports.default = resetPasswordComponent;

/***/ }),

/***/ 502:
/***/ (function(module, exports) {

	module.exports = "<div id=\"kt_body\" class=\"header-fixed header-mobile-fixed subheader-enabled subheader-fixed aside-enabled aside-fixed aside-minimize-hoverable page-loading\">\n  <cpwd></cpwd>\n</div>\n"

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResetPasswordController = function ResetPasswordController() {
	  (0, _classCallCheck3.default)(this, ResetPasswordController);
	
	  this.name = 'resetPassword';
	};
	
	exports.default = ResetPasswordController;

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(505);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(457)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./resetPassword.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./resetPassword.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(456)();
	// imports
	
	
	// module
	exports.push([module.id, ".resetPassword{color:red}", ""]);
	
	// exports


/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(335);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _auth = __webpack_require__(507);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var authModule = _angular2.default.module('auth', [_angularUiRouter2.default]).component('auth', _auth2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('auth', {
	    url: '',
	    component: 'auth'
	  });
	}]).name;
	
	exports.default = authModule;

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(508);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _auth3 = __webpack_require__(509);
	
	var _auth4 = _interopRequireDefault(_auth3);
	
	__webpack_require__(510);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var authComponent = {
	  bindings: {},
	  template: _auth2.default,
	  controller: _auth4.default
	};
	
	exports.default = authComponent;

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

	module.exports = "<div id=\"kt_body\"\n  class=\"header-fixed header-mobile-fixed subheader-enabled subheader-fixed aside-enabled aside-fixed aside-minimize-hoverable page-loading\">\n  <!--begin::Main-->\n  <div class=\"d-flex flex-column flex-root\">\n    <!--begin::Login-->\n    <div class=\"login login-3 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white\" id=\"kt_login\">\n      <!--begin::Aside-->\n      <div class=\"login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10\">\n        <!--begin: Aside Container-->\n        <div class=\"d-flex flex-row-fluid flex-column justify-content-between\">\n          <!--begin: Aside content-->\n          <a href=\"#\" class=\"flex-column-auto mt-5\">\n            <img src=\"assets/app/logo-white-full.png\" />\n          </a>\n          <div class=\"flex-column-fluid d-flex flex-column justify-content-center\">\n          </div>\n          <!--end: Aside content-->\n          <!--begin: Aside footer for desktop-->\n          <div class=\"d-none flex-column-auto d-lg-flex justify-content-between mt-10\">\n            <div class=\"opacity-70 font-weight-bold text-white\"><a class=\"text-white\" href=\"/\">© {{ $ctrl.currentYear }}\n                Homesite Selections</a></div>\n          </div>\n          <!--end: Aside footer for desktop-->\n        </div>\n        <!--end: Aside Container-->\n      </div>\n      <!--begin::Aside-->\n      <!--begin::Content-->\n      <div class=\"flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden\" ui-view>\n      </div>\n      <!--end::Content-->\n    </div>\n    <!--end::Login-->\n  </div>\n  <!--end::Main-->\n  <!--begin::Page Scripts(used by this page)-->\n  <script src=\"assets/js/pages/custom/login/login.js\"></script>\n  <!--end::Page Scripts-->\n</div>\n"

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(425);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthController = function () {
	  function AuthController() {
	    (0, _classCallCheck3.default)(this, AuthController);
	
	    this.name = 'auth';
	    this.currentYear = new Date().getFullYear();
	  }
	
	  (0, _createClass3.default)(AuthController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      //Hdd to do this here since webpack was giving me an issue in css
	      $('.login-aside').css('background-image', 'url("assets/app/lot_bg.png")');
	    }
	  }]);
	  return AuthController;
	}();
	
	exports.default = AuthController;

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(511);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(457)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./auth.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./auth.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(456)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(335);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _editProfile = __webpack_require__(513);
	
	var _editProfile2 = _interopRequireDefault(_editProfile);
	
	var _accessRules = __webpack_require__(452);
	
	var _accessRules2 = _interopRequireDefault(_accessRules);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var editProfileModule = _angular2.default.module('editProfile', [_angularUiRouter2.default]).component('editProfile', _editProfile2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('main.editProfile', {
	    name: 'main.editProfile',
	    url: '/editProfile',
	    component: 'editProfile',
	    data: { protected: true, rolesRequired: _accessRules2.default.EDIT_PROFILE },
	    params: { id: undefined }
	  });
	}]).name;
	
	exports.default = editProfileModule;

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _editProfile = __webpack_require__(514);
	
	var _editProfile2 = _interopRequireDefault(_editProfile);
	
	var _editProfile3 = __webpack_require__(515);
	
	var _editProfile4 = _interopRequireDefault(_editProfile3);
	
	__webpack_require__(517);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var editProfileComponent = {
	  bindings: {},
	  template: _editProfile2.default,
	  controller: _editProfile4.default
	};
	
	exports.default = editProfileComponent;

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

	module.exports = "<div class=\"d-flex flex-column-fluid mt-40 justify-content-center\">\n  <div id=\"editProfile\" class=\"flex-center card card-custom px-20 py-5 w-50\">\n    <div class=\"mb-10\">\n      <div class=\"font-size-h1\">Edit Profile</div>\n    </div>\n    <form class=\"form w-100\" id=\"profile_form\">\n      <div class=\"form-group\">\n        <label for=\"firstName\">First Name</label>\n        <input id=\"firstName\" type=\"text\" class=\"form-control form-control-solid\" name=\"requiredField\"/>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"lastName\">Last Name</label>\n        <input id=\"lastName\"  type=\"text\" class=\"form-control form-control-solid\" name=\"requiredField\"/>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"title\">Title</label>\n        <input id=\"title\" type=\"text\" class=\"form-control form-control-solid\" name=\"optionalField\"/>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"addressLine1\">Address (Line 1)</label>\n        <input id=\"addressLine1\"  type=\"text\" class=\"form-control form-control-solid\" name=\"requiredField\"/>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"addressLine2\">Address (Line 2)</label>\n        <input id=\"addressLine2\" type=\"text\" class=\"form-control form-control-solid\" name=\"optionalField\"/>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"city\">City</label>\n        <input id=\"city\"  type=\"text\" class=\"form-control form-control-solid\" name=\"requiredField\"/>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"state\">State</label>\n        <input id=\"state\" type=\"text\" class=\"form-control form-control-solid\" name=\"requiredState\"/>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"zipcode\">Zipcode</label>\n        <input id=\"zipcode\"  type=\"text\" class=\"form-control form-control-solid\" name=\"requiredField\"/>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"workPhone\">Work Phone</label>\n        <input id=\"workPhone\"  type=\"text\" class=\"form-control form-control-solid phone\" name=\"requiredPhoneNumber\"/>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"cellPhone\">Mobile Phone</label>\n        <input id=\"cellPhone\"  type=\"text\" class=\"form-control form-control-solid phone\" name=\"requiredPhoneNumber\"/>\n      </div>\n      <div class=\"card-footer row justify-content-center\">\n        <button class=\"btn btn-primary font-weight-bold w-75\" ng-click=\"$ctrl.saveProfile()\">Save</button>\n      </div>\n    </form>\n  </div>\n</div>\n"

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(425);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _dialogUtil = __webpack_require__(468);
	
	var _dialogUtil2 = _interopRequireDefault(_dialogUtil);
	
	var _apiStatus = __webpack_require__(471);
	
	var _apiStatus2 = _interopRequireDefault(_apiStatus);
	
	var _formValidationUtil = __webpack_require__(516);
	
	var _formValidationUtil2 = _interopRequireDefault(_formValidationUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditProfileController = function () {
	  EditProfileController.$inject = ["AuthService", "$state", "$scope"];
	  function EditProfileController(AuthService, $state, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, EditProfileController);
	    this.name = 'editProfile';
	    this.formId = "profile_form";
	    //this.clientService = ClientService;
	    this.authService = AuthService;
	    this.scope = $scope;
	    this.state = $state;
	    this.userProfile = undefined;
	    this.formValidator = undefined;
	  }
	
	  (0, _createClass3.default)(EditProfileController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.formValidator = _formValidationUtil2.default.initValidation(this.formId);
	      this.populateUserProfile();
	
	      $("input").attr("autocomplete", "off"); //turn autocomplete off on all input fields
	
	      var parent = this;
	      $('#' + this.formId + ' .phone').on('input', function (event) {
	        var inputType = event.originalEvent.inputType;
	
	        if (inputType && !inputType.startsWith('insert')) {
	          return;
	        }
	
	        //only format if not erasing
	        parent.formatPhone($(this));
	
	        if (!inputType) {
	          parent.formValidator.validate();
	        }
	      });
	    }
	  }, {
	    key: 'formatPhone',
	    value: function formatPhone(elem) {
	      var phoneNumber = elem.val();
	
	      var cleanNum = phoneNumber.toString().replace(/[\-]/g, '');
	      var match = cleanNum.match(/^(\d{3,3})(\d{0,3})(\d{0,4})(.*)$/);
	
	      var newPhone = phoneNumber;
	      if (match) {
	        newPhone = match[1] + '-' + (match[2] ? match[2].length < 3 ? match[2] : match[2] + "-" : "") + match[3] + match[4];
	      }
	
	      $(elem).val(newPhone);
	    }
	  }, {
	    key: 'populateUserProfile',
	    value: function populateUserProfile() {
	      var _this = this;
	
	      this.authService.getUserProfile(function (result) {
	        if (result.apiStatus === _apiStatus2.default.SUCCESS) {
	          _this.userProfile = result.data;
	          _formValidationUtil2.default.setFormDetails(_this.formId, _this.userProfile);
	        } else {
	          _dialogUtil2.default.showErrorMessage("Error getting user profile: " + result.apiStatus);
	        }
	      });
	    }
	  }, {
	    key: 'saveProfile',
	    value: function saveProfile() {
	      var tmpData = _formValidationUtil2.default.validateFormDetails(this.formId);
	
	      if (!tmpData) {
	        _dialogUtil2.default.showErrorMessage("Please review and fix all fields before resubmitting");
	      } else {
	        this.authService.updateUserProfile(tmpData, function (result) {
	          if (result.apiStatus === _apiStatus2.default.SUCCESS) {
	            _dialogUtil2.default.showSuccessMessage("Profile updated successfully!");
	          } else {
	            _dialogUtil2.default.showErrorMessage("Error updating user profile: " + result.apiStatus);
	          }
	        });
	      }
	    }
	  }]);
	  return EditProfileController;
	}();
	
	exports.default = EditProfileController;

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

	'use strict';
	
	var isPhoneNumber = function isPhoneNumber() {
	  // return {
	  //   validate: function (input) {
	  //     const phoneInput = input.value;
	  //     //const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
	  //
	  //     const phoneRegex = /^\([0-9]{3}\) [0-9]{3}\-[0-9]{4}$/
	  //
	  //     if (phoneInput.match(phoneRegex)) {
	  //       return { valid: true }
	  //     }
	  //
	  //     return { valid: false }
	  //   }
	  // }
	  //This is the new validation...ddd-ddd-dddd{anything for extensions}
	  return {
	    validate: function validate(input) {
	      var phoneInput = input.value;
	      var phoneRegex = /^(\d{3})-(\d{3})-(\d{4})(.*)$/;
	
	      return { valid: phoneInput.match(phoneRegex) };
	    }
	  };
	};
	
	var isOptionalPhoneNumber = function isOptionalPhoneNumber() {
	  return {
	    validate: function validate(input) {
	      var phoneInput = input.value;
	      var phoneRegex = /^(\d{3})-(\d{3})-(\d{4})(.*)$/;
	
	      return { valid: phoneInput === '' || phoneInput.match(phoneRegex) };
	    }
	  };
	};
	
	var isValidEmail = function isValidEmail() {
	  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	  return {
	    validate: function validate(input) {
	      var email = input.value;
	      return { valid: re.test(String(email).toLowerCase()) };
	    }
	  };
	};
	
	var isOptionalEmail = function isOptionalEmail() {
	  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	  return {
	    validate: function validate(input) {
	      var email = input.value;
	      return { valid: email === '' || re.test(String(email).toLowerCase()) };
	    }
	  };
	};
	
	var isValidZipCode = function isValidZipCode() {
	  var re = /^[0-9]{5}$/;
	
	  return {
	    validate: function validate(input) {
	      var zip = input.value;
	      return { valid: re.test(String(zip).toLowerCase()) };
	    }
	  };
	};
	
	var isValid2DigitState = function isValid2DigitState() {
	  var states = ["AK", "AL", "AR", "AS", "AZ", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "GU", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VI", "VT", "WA", "WI", "WV", "WY"];
	
	  return {
	    validate: function validate(input) {
	      var state = input.value;
	      if (state) {
	        state = state.toUpperCase();
	      }
	      return { valid: states.findIndex(function (e) {
	          return e === state;
	        }) >= 0 };
	    }
	  };
	};
	
	exports.validateFormDetails = function (form_id) {
	  var data = {};
	  var issues = false;
	
	  //Do inputs and selects
	  $("#" + form_id + " input, #" + form_id + " select").each(function () {
	    var id = $(this).attr('id');
	    var invalid = $(this).hasClass("is-invalid"); //having a name means it is a required field
	
	    if (invalid) {
	      issues = true;
	    }
	    if (id) {
	      data[id] = $(this).val();
	    }
	  });
	
	  if (issues) {
	    return;
	  }
	
	  return data;
	};
	
	exports.setFormDetails = function (form_id, data) {
	  //do input fields
	  $("#" + form_id + " input").each(function () {
	    var id = $(this).attr('id');
	    $(this).val(data[id] ? data[id] : '');
	  });
	
	  //do select fields
	  $("#" + form_id + " select").each(function () {
	    var id = $(this).attr('id');
	    if (data[id]) {
	      $(this).val(data[id]);
	    } else {
	      this.selectedIndex = 0;
	    }
	  });
	};
	
	exports.initValidation = function (formId) {
	  FormValidation.validators.checkOptionalPhoneNumber = isOptionalPhoneNumber;
	  FormValidation.validators.checkOptionalEmailAddress = isOptionalEmail;
	  FormValidation.validators.checkPhoneNumber = isPhoneNumber;
	  FormValidation.validators.checkEmailAddress = isValidEmail;
	  FormValidation.validators.checkZipCode = isValidZipCode;
	  FormValidation.validators.check2DigitState = isValid2DigitState;
	
	  var fieldsNeeded = {
	    requiredField: {
	      validators: {
	        notEmpty: {
	          message: 'Field is required'
	        }
	      }
	    },
	    optionalField: {
	      validators: {}
	    }
	
	  };
	  inputs = $("#" + formId + " input[name='optionalPhoneNumber']");
	  if (inputs.length > 0) {
	    fieldsNeeded['optionalPhoneNumber'] = {
	      validators: {
	        checkOptionalPhoneNumber: {
	          message: "Please enter a valid phone number"
	        }
	      }
	    };
	  }
	  inputs = $("#" + formId + " input[name='optionalEmail']");
	  if (inputs.length > 0) {
	    fieldsNeeded['optionalEmail'] = {
	      validators: {
	        checkOptionalEmailAddress: {
	          message: "Please enter a valid email address"
	        }
	      }
	    };
	  }
	
	  var inputs = $("#" + formId + " input[name='requiredPhoneNumber']");
	  if (inputs.length > 0) {
	    fieldsNeeded['requiredPhoneNumber'] = {
	      validators: {
	        checkPhoneNumber: {
	          message: "Please enter a valid phone number"
	        }
	      }
	    };
	  }
	  inputs = $("#" + formId + " input[name='requiredEmail']");
	  if (inputs.length > 0) {
	    fieldsNeeded['requiredEmail'] = {
	      validators: {
	        checkEmailAddress: {
	          message: "Please enter a valid email address"
	        }
	      }
	    };
	  }
	
	  inputs = $("#" + formId + " input[name='requiredZipCode']");
	  if (inputs.length > 0) {
	    fieldsNeeded['requiredZipCode'] = {
	      validators: {
	        checkZipCode: {
	          message: "Please enter a valid zip code"
	        }
	      }
	    };
	  }
	
	  inputs = $("#" + formId + " input[name='requiredState']");
	  if (inputs.length > 0) {
	    fieldsNeeded['requiredState'] = {
	      validators: {
	        check2DigitState: {
	          message: "Please enter a valid 2-character state"
	        }
	      }
	    };
	  }
	
	  inputs = $("#" + formId + " select[name='requiredOption']");
	  if (inputs.length > 0) {
	    fieldsNeeded['requiredOption'] = {
	      validators: {
	        notEmpty: {
	          message: 'Please select an option'
	        }
	      }
	    };
	  }
	
	  return FormValidation.formValidation(document.getElementById(formId), {
	    fields: fieldsNeeded,
	    plugins: {
	      trigger: new FormValidation.plugins.Trigger(),
	      bootstrap: new FormValidation.plugins.Bootstrap(),
	      submitButton: new FormValidation.plugins.SubmitButton()
	    }
	  });
	};

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(518);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(457)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./editProfile.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./editProfile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(456)();
	// imports
	
	
	// module
	exports.push([module.id, "#editProfile{max-width:500px}", ""]);
	
	// exports


/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(335);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _user = __webpack_require__(520);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userModule = _angular2.default.module('user', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('main.user', {
	    name: "main.user",
	    url: '/user',
	    component: 'user',
	    data: { protected: true, topMenu: 'User Maintenance' }
	  });
	}]).component('user', _user2.default).name;
	
	exports.default = userModule;

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _user = __webpack_require__(521);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _user3 = __webpack_require__(522);
	
	var _user4 = _interopRequireDefault(_user3);
	
	__webpack_require__(588);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userComponent = {
	  bindings: {},
	  template: _user2.default,
	  controller: _user4.default
	};
	
	exports.default = userComponent;

/***/ }),

/***/ 521:
/***/ (function(module, exports) {

	module.exports = "<div class=\"d-flex flex-column-fluid justify-content-center\">\n  <div id=\"userPage\" class=\"flex-center card card-custom mt-20 px-20 py-5 w-75\">\n    <div class=\"mb-10\">\n      <div class=\"font-size-h1\">User Maintenance</div>\n    </div>\n    <div id=\"mainPage\" class=\"d-flex w-100 justify-content-center\">\n      <div id=\"leftColumn\">\n        <label for=\"search_query\" class=\"boldTitle\">User Search</label>\n        <div class=\"input-icon mb-2\">\n          <input type=\"text\" class=\"form-control form-control-solid\" placeholder=\"Search...\"\n                 id=\"search_query\">\n          <span><i class=\"fa fa-search text-muted\"></i></span>\n        </div>\n        <br>\n        <div class=\"boldTitle\">Filter Users by Status</div>\n        <br>\n        <div class=\"radioGroup align-items-start\">\n          <input type=\"radio\" id=\"active\" name=\"userStatus\" value=\"A\" checked ng-click=\"$ctrl.filterUsers()\">\n          <label for=\"active\">Active</label>\n          <input type=\"radio\" id=\"inactive\" name=\"userStatus\" value=\"I\" ng-click=\"$ctrl.filterUsers()\">\n          <label for=\"inactive\">Inactive</label><br>\n        </div>\n        <div id=\"userContainer\">\n          <div class=\"userRow cursor-pointer\" ng-repeat=\"user in $ctrl.filteredUsers\" id=\"{{user.id}}\">\n            <span class=\"profileImage\">{{user.initials}}</span>\n            {{user.name}}\n          </div>\n        </div>\n      </div>\n      <div id=\"rightColumn\">\n        <div class=\"card-header card-header-tabs-line nav-tabs-line-3x\">\n          <!--begin::Toolbar-->\n          <div class=\"card-toolbar\">\n            <ul class=\"nav nav-tabs nav-bold nav-tabs-line nav-tabs-line-3x\">\n              <!--begin::Item-->\n              <li class=\"nav-item mr-3\">\n                <a class=\"nav-link active\" data-toggle=\"tab\" href=\"#edit_user\">\n                  <span class=\"nav-icon fas fa-pen\"></span>\n                  <span class=\"nav-text font-size-lg\">User Information</span>\n                </a>\n              </li>\n              <!--begin::Item-->\n              <li class=\"nav-item mr-3\">\n                <a id=\"permissionsLink\" class=\"nav-link\" data-toggle=\"tab\" href=\"#permissions\">\n                  <span class=\"nav-icon fas fa-shield-alt\"></span>\n                  <span class=\"nav-text font-size-lg\">Permissions</span>\n                </a>\n              </li>\n            </ul>\n          </div>\n          <!--end::Toolbar-->\n        </div>\n        <div class=\"tab-content\">\n          <!--begin::Tab-->\n          <div class=\"tab-pane show active px-7\" id=\"edit_user\" role=\"tabpanel\">\n\n            <div class=\"d-flex justify-content-between\">\n              <h2>User Profile</h2>\n              <button id=\"resetPasswordButton\" type=\"submit\" class=\"btn btn-primary font-weight-bold px-7\"\n                      ng-if=\"$ctrl.showResetPasswordButton()\" ng-click=\"$ctrl.resetPasswordClicked()\">Reset Password\n              </button>\n              <button id=\"addUserButton\" type=\"submit\" class=\"btn btn-primary font-weight-bold px-7\"\n                      ng-click=\"$ctrl.newUserClicked()\">+ New User\n              </button>\n            </div>\n            <form class=\"form\" id=\"user_form\">\n              <div class=\"scroll\">\n                <div class=\"form-group\">\n                  <label for=\"username\">Username (email)</label>\n                  <input data-ng-model=\"$ctrl.clickedData.username\" id=\"username\" type=\"text\" class=\"form-control form-control-solid\" name=\"requiredEmail\"/>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"firstName\">First Name</label>\n                  <input data-ng-model=\"$ctrl.clickedData.firstName\" id=\"firstName\" type=\"text\" class=\"form-control form-control-solid\" name=\"requiredField\"/>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"lastName\">Last Name</label>\n                  <input data-ng-model=\"$ctrl.clickedData.lastName\" id=\"lastName\" type=\"text\" class=\"form-control form-control-solid\" name=\"requiredField\"/>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"title\">Title</label>\n                  <input data-ng-model=\"$ctrl.clickedData.title\" id=\"title\" type=\"text\" class=\"form-control form-control-solid\" name=\"optionalField\"/>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"addressLine1\">Address (Line 1)</label>\n                  <input data-ng-model=\"$ctrl.clickedData.addressLine1\" id=\"addressLine1\" type=\"text\" class=\"form-control form-control-solid\" name=\"requiredField\"/>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"addressLine2\">Address (Line 2)</label>\n                  <input data-ng-model=\"$ctrl.clickedData.addressLine2\" id=\"addressLine2\" type=\"text\" class=\"form-control form-control-solid\" name=\"optionalField\"/>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"city\">City</label>\n                  <input data-ng-model=\"$ctrl.clickedData.city\" id=\"city\" type=\"text\" class=\"form-control form-control-solid\" name=\"requiredField\"/>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"state\">State</label>\n                  <input data-ng-model=\"$ctrl.clickedData.state\" id=\"state\" type=\"text\" class=\"form-control form-control-solid\" name=\"requiredState\"/>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"zipcode\">Zipcode</label>\n                  <input data-ng-model=\"$ctrl.clickedData.zipcode\" id=\"zipcode\" type=\"text\" class=\"form-control form-control-solid\" name=\"requiredField\"/>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"workPhone\">Work Phone</label>\n                  <input data-ng-model=\"$ctrl.clickedData.workPhone\" id=\"workPhone\" type=\"text\" class=\"form-control form-control-solid phone\"\n                         name=\"optionalPhoneNumber\"/>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"cellPhone\">Mobile Phone</label>\n                  <input data-ng-model=\"$ctrl.clickedData.cellPhone\" id=\"cellPhone\" type=\"text\" class=\"form-control form-control-solid phone\"\n                         name=\"optionalPhoneNumber\"/>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"type\">Type</label>\n                  <i\n                    title=\"Online users have login access to the system. Notify Only users will only get Takedown notifications. Contact users are just for reference. Most users will be Online.\"\n                    class=\"fas fa-info-circle\"></i>\n                  <select data-ng-model=\"$ctrl.clickedData.type\" id=\"type\" class=\"form-control form-control-solid selectpicker1\">\n                    <option value=\"O\">Online</option>\n                    <option value=\"N\">Notify Only</option>\n                    <option value=\"C\">Contact</option>\n                  </select>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"status\">Status</label>\n                  <select data-ng-model=\"$ctrl.clickedData.status\" id=\"status\" class=\"form-control form-control-solid selectpicker1\">\n                    <option value=\"A\">Active</option>\n                    <option value=\"I\">Inactive</option>\n                  </select>\n                </div>\n\n                <h2>New User System Access</h2>\n                <div class=\"appRow\" ng-repeat=\"app in $ctrl.allAppsRoles\">\n                  <div class=\"form-group\">\n                    <label for=\"appId{{app.appId}}\">{{app.appName}}</label>\n                    <select data-ng-model=\"$ctrl.userAppRole[app.appId-1]\" ng-options=\"item.id as item.name for item in app.appRoleList\"\n                            class=\"roleSelect form-control form-control-solid selectpicker1\" id=\"appId{{app.appId}}\">\n                    </select>\n                  </div>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"portalAdmin\">Portal Admin Access</label>\n                  <input data-ng-model=\"$ctrl.userAppRole[0]\" id=\"portalAdmin\" type=\"checkbox\" class=\"ml-5\"\n                         style=\"font-size:2rem\"/>\n                </div>\n              </div>\n              <div class=\"card-footer\">\n                <button id=\"updateButton\" type=\"submit\" class=\"btn btn-primary font-weight-bold px-7 w-100\"\n                        ng-click=\"$ctrl.saveButtonClicked()\">Save\n                </button>\n              </div>\n            </form>\n          </div>\n          <div class=\"tab-pane px-7\" id=\"permissions\" role=\"tabpanel\">\n            <div ng-show=\"$ctrl.getPermissionType() === 0\">\n              Select a user or save the current user to add permissions\n            </div>\n            <div ng-show=\"$ctrl.getPermissionType() === 1\">\n              Current role assignment does not require permissions\n            </div>\n            <div ng-show=\"$ctrl.getPermissionType() === 3\">\n              Contact Only users do not require permissions\n            </div>\n\n            <div ng-show=\"$ctrl.getPermissionType() === 2\">\n\n            <div class=\"row\">\n              <div class=\"col-lg-6\">\n                <h5 style=\"text-align:center\">Select Divisions to grant Permissions</h5>\n                <div id=\"permissions-tree-division\" class=\"tree-demo jstree jstree-2 jstree-default\" role=\"tree\"\n                     aria-multiselectable=\"true\" tabindex=\"0\" aria-busy=\"false\" style=\"max-height:400px;\">\n                </div>\n              </div>\n              <div class=\"col-lg-6\">\n                <h5>Select Projects to grant Permissions</h5>\n                <div id=\"permissions-tree-project\" class=\"tree-demo jstree jstree-2 jstree-default\" role=\"tree\"\n                     aria-multiselectable=\"true\" tabindex=\"0\" aria-busy=\"false\" style=\"max-height:400px;\">\n                </div>\n              </div>\n\n            </div>\n            <!--begin::Row-->\n            <hr/>\n            <h5 style=\"text-align:center\">Current Project Access</h5>\n            <div\n              class=\"datatable datatable-head-custom datatable-default datatable-primary\"\n              id=\"permission-project-access\">\n            </div>\n            <!--end::Row-->\n            <div class=\"card-footer\">\n              <button id=\"permButton\" type=\"submit\" class=\"btn btn-primary font-weight-bold px-7 w-100\"\n                      ng-click=\"$ctrl.savePermissions()\">Save\n              </button>\n            </div>\n            </div>\n          </div>\n          <!--end::Body-->\n        </div>\n      </div> <!-- end tabcontent -->\n    </div>\n  </div>\n</div>\n\n<!--Popup HTML for Reset Password-->\n<div id=\"resetPasswordPopup\" ng-show=false>\n  <ul style=\"opacity:0.8;text-align:left\">\n    <li>Password must be at least 8 characters</li>\n    <li>Password cannot contain common words</li>\n    <li>Password cannot contain 3 or more duplicate or sequential characters (e.g. rrr, 123, abc)</li>\n  </ul>\n  <form class=\"form text-left\" id=\"resetPasswordForm\">\n    <div>\n      <label for=\"password1\">New Password</label>\n      <input id=\"password1\" type=\"password\" class=\"form-control form-control-solid\"/>\n    </div>\n  </form>\n  <div id=\"resetPasswordError\">&nbsp;</div>\n</div>\n\n"

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(523);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(526);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getIterator2 = __webpack_require__(581);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(425);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _apiStatus = __webpack_require__(471);
	
	var _apiStatus2 = _interopRequireDefault(_apiStatus);
	
	var _dialogUtil = __webpack_require__(468);
	
	var _dialogUtil2 = _interopRequireDefault(_dialogUtil);
	
	var _formValidationUtil = __webpack_require__(516);
	
	var _formValidationUtil2 = _interopRequireDefault(_formValidationUtil);
	
	var _userRoles = __webpack_require__(453);
	
	var _userRoles2 = _interopRequireDefault(_userRoles);
	
	var _sweetalert = __webpack_require__(469);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _treeUtil = __webpack_require__(584);
	
	var _treeUtil2 = _interopRequireDefault(_treeUtil);
	
	var _datatableUtil = __webpack_require__(586);
	
	var _datatableUtil2 = _interopRequireDefault(_datatableUtil);
	
	var _nodeType = __webpack_require__(587);
	
	var _nodeType2 = _interopRequireDefault(_nodeType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserController = function () {
	  UserController.$inject = ["ClientService", "AuthService", "$scope", "$state"];
	  function UserController(ClientService, AuthService, $scope, $state) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UserController);
	    this.name = 'user';
	    this.formId = 'user_form';
	
	    this.clientService = ClientService;
	    this.authService = AuthService;
	    this.scope = $scope;
	    this.state = $state;
	    this.allUsers = [];
	    this.filteredUsers = [];
	    this.allAppsRoles = [];
	    this.formValidator = undefined;
	    this.resetForm();
	
	    this.permissionsTreeIdDivision = "permissions-tree-division";
	    this.permissionsTreeIdProject = "permissions-tree-project";
	    this.userPermissionsDivision = undefined;
	    this.userPermissionsProject = undefined;
	    this.checkboxTreeOptions = { checkbox: "true" };
	    this.PROJECT_ACCESS_COLUMNS = [{
	      field: 'region',
	      title: 'Region',
	      textAlign: 'left'
	    }, {
	      field: 'division',
	      title: 'Division',
	      textAlign: 'left'
	    }, {
	      field: 'community',
	      title: 'Community',
	      textAlign: 'left'
	    }];
	  }
	
	  (0, _createClass3.default)(UserController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      $('.app').css('background-image', '');
	
	      var parent = this;
	      $(document).ready(function () {
	        _treeUtil2.default.initializeTree(parent.permissionsTreeIdDivision, parent.userPermissionsDivision, parent.checkboxTreeOptions);
	        _treeUtil2.default.initializeTree(parent.permissionsTreeIdProject, parent.userPermissionsProject, parent.checkboxTreeOptions);
	      });
	
	      $("input").attr("autocomplete", "off"); //turn autocomplete off on all input fields
	
	      this.formValidator = _formValidationUtil2.default.initValidation(this.formId);
	
	      $('#search_query').on('input', function () {
	        parent.filterUsers();
	        parent.scope.$apply();
	      });
	
	      $('#userContainer').on('click', '.userRow', function () {
	        parent.rowClicked(this);
	      });
	
	      $('#' + parent.formId + ' .phone').on('input', function (event) {
	        var inputType = event.originalEvent.inputType;
	
	        if (inputType && !inputType.startsWith('insert')) {
	          return;
	        }
	
	        //only format if not erasing
	        parent.formatPhone($(this));
	
	        if (!inputType) {
	          parent.formValidator.validate();
	        }
	      });
	
	      this.getAllUsersApplicationsRoles();
	      this.getAllApplicationsRoles();
	    }
	  }, {
	    key: "resetForm",
	    value: function resetForm() {
	      this.clickedData = {};
	      this.userAppRole = [false, 0, 0, 0, 0, 0, 0, 0, 0, 0]; //This has to be as long as the number of apps
	    }
	  }, {
	    key: "formatPhone",
	    value: function formatPhone(elem) {
	      var phoneNumber = elem.val();
	
	      var cleanNum = phoneNumber.toString().replace(/[\-]/g, '');
	      var match = cleanNum.match(/^(\d{3,3})(\d{0,3})(\d{0,4})(.*)$/);
	
	      var newPhone = phoneNumber;
	      if (match) {
	        newPhone = match[1] + '-' + (match[2] ? match[2].length < 3 ? match[2] : match[2] + "-" : "") + match[3] + match[4];
	      }
	
	      $(elem).val(newPhone);
	    }
	  }, {
	    key: "getAllApplicationsRoles",
	    value: function getAllApplicationsRoles() {
	      var _this = this;
	
	      this.clientService.getAllApplicationsRoles(function (result) {
	
	        if (result.apiStatus === _apiStatus2.default.SUCCESS) {
	          _this.allAppsRoles = result.dataList;
	
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(_this.allAppsRoles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var appRole = _step.value;
	
	              appRole.appRoleList.splice(0, 0, { name: 'No Access', id: 0 });
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          _this.scope.$apply();
	        } else {
	          _dialogUtil2.default.showErrorMessage("Error getting applications: " + result.apiStatus);
	        }
	      });
	    }
	  }, {
	    key: "getAllUsersApplicationsRoles",
	    value: function getAllUsersApplicationsRoles() {
	      var _this2 = this;
	
	      this.clientService.getAllUsersApplicationsRoles(function (result) {
	        if (result.apiStatus === _apiStatus2.default.SUCCESS) {
	          _this2.allUsers = result.dataList;
	          _this2.filterUsers();
	          _this2.scope.$apply();
	          _this2.formValidator.resetForm();
	        } else {
	          _dialogUtil2.default.showErrorMessage("Error getting users: " + result.apiStatus);
	        }
	      });
	    }
	  }, {
	    key: "filterUsers",
	    value: function filterUsers() {
	      var _this3 = this;
	
	      var searchText = $('#search_query').val();
	
	      var userStatus = $('input[name="userStatus"]:checked').val();
	
	      this.filteredUsers = [];
	
	      this.allUsers.forEach(function (user) {
	        var fullName = (user.firstName + ' ' + user.lastName).toLowerCase();
	        if (user.status === userStatus && (searchText.length < 1 || fullName.includes(searchText.toLowerCase()))) {
	          _this3.filteredUsers.push({
	            id: user.userId,
	            name: user.firstName + ' ' + user.lastName,
	            initials: user.firstName.charAt(0) + user.lastName.charAt(0)
	          });
	        }
	      });
	    }
	  }, {
	    key: "getUserRoleSelected",
	    value: function getUserRoleSelected(roleId) {
	      return this.clickedData.appRoleIdList && this.clickedData.appRoleIdList.includes(roleId);
	    }
	  }, {
	    key: "showResetPasswordButton",
	    value: function showResetPasswordButton() {
	      return this.clickedData.type === 'O';
	    }
	  }, {
	    key: "rowClicked",
	    value: function rowClicked(element) {
	      //Remove the highlight from any other div
	      $(element).parent('div').find('div').removeClass('highlight');
	      $(element).addClass('highlight');
	
	      var id = parseInt($(element).attr('id'));
	
	      this.clickedData = this.allUsers.find(function (elem) {
	        return elem.userId === id;
	      });
	      this.formValidator.resetForm();
	
	      this.updateUserRoleState();
	
	      this.getUserPermissions();
	
	      this.scope.$apply(); //Needed to show the Reset Password button on select
	    }
	  }, {
	    key: "updateUserRoleState",
	    value: function updateUserRoleState() {
	
	      //Figure out which role for each application that this user has
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.allAppsRoles), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var app = _step2.value;
	
	          var appId = app.appId;
	          this.userAppRole[appId - 1] = 0; //default to no access unless I find it
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = (0, _getIterator3.default)(this.clickedData.appRoleIdList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var userRoleId = _step3.value;
	              var _iteratorNormalCompletion4 = true;
	              var _didIteratorError4 = false;
	              var _iteratorError4 = undefined;
	
	              try {
	                for (var _iterator4 = (0, _getIterator3.default)(app.appRoleList), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                  var appRole = _step4.value;
	
	                  if (appRole.id === userRoleId) {
	                    this.userAppRole[appId - 1] = userRoleId;
	                  }
	                }
	              } catch (err) {
	                _didIteratorError4 = true;
	                _iteratorError4 = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                    _iterator4.return();
	                  }
	                } finally {
	                  if (_didIteratorError4) {
	                    throw _iteratorError4;
	                  }
	                }
	              }
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      this.userAppRole[0] = this.clickedData.appRoleIdList.includes(1);
	    }
	  }, {
	    key: "newUserClicked",
	    value: function newUserClicked() {
	      this.resetForm();
	      this.formValidator.resetForm();
	      this.scope.$apply();
	    }
	  }, {
	    key: "getRoleData",
	    value: function getRoleData(data) {
	      var roleList = [];
	      this.allAppsRoles.forEach(function (elem) {
	        //go through the apps and get the dropdown value for each, which is already in the data as appId{appId}
	        var key = 'appId' + elem.appId;
	        var value = data[key];
	        if (value !== 'number:0') {
	          roleList.push(value.split(':')[1]);
	        }
	        data[key] = null;
	      });
	
	      //checkboxes are different in that the val is the same checked or unchecked, so need to be different here
	      roleList.push($('#portalAdmin').is(":checked") ? '' + _userRoles2.default.PORTAL_ADMIN : '' + _userRoles2.default.PORTAL_USER);
	
	      data['applicationRoleIds'] = roleList;
	    }
	  }, {
	    key: "saveButtonClicked",
	    value: function saveButtonClicked() {
	      var _this4 = this;
	
	      var tmpData = _formValidationUtil2.default.validateFormDetails(this.formId);
	
	      if (!tmpData) {
	        _dialogUtil2.default.showErrorMessage("Please review and fix all fields before resubmitting");
	        return;
	      } else {
	        this.getRoleData(tmpData);
	      }
	
	      this.clientService.updateUser(this.clickedData.userId, tmpData, function (result) {
	        if (result.apiStatus === "SUCCESS") {
	          _this4.state.reload(); //refresh the page
	          _dialogUtil2.default.showSuccessMessage("User saved Successfully");
	        } else {
	          _dialogUtil2.default.showErrorMessage("User save failed");
	        }
	      });
	    }
	
	    //Called from the table to edit comment;  also called from the function from the HTML
	
	  }, {
	    key: "resetPasswordClicked",
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        var parent, popupHtml, _ref2, newPassword;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                parent = this;
	                popupHtml = $("#resetPasswordPopup").html();
	
	                popupHtml = popupHtml.replaceAll('password1', 'p1').replaceAll('resetPasswordError', 'rpe');
	                _context.next = 5;
	                return _sweetalert2.default.fire({
	                  title: 'Reset Password',
	                  html: popupHtml,
	                  showCancelButton: true,
	                  width: '30%',
	                  inputAttributes: {
	                    id: "resetPswdPopup"
	                  },
	                  preConfirm: function preConfirm() {
	                    var p1 = $('#p1').val();
	                    if (p1.length < 8) {
	                      $('#rpe').html('Passwords must be at least 8 characters');
	                      return false;
	                    }
	
	                    return p1;
	                  }
	                });
	
	              case 5:
	                _ref2 = _context.sent;
	                newPassword = _ref2.value;
	
	                if (newPassword) {
	                  parent.authService.resetPasswordForUser(parent.clickedData.userId, newPassword, function (result) {
	                    if (result.apiStatus === 'SUCCESS') {
	                      _dialogUtil2.default.showSuccessMessage("Password Reset!");
	                    } else {
	                      _dialogUtil2.default.showErrorMessage("Error resetting password: " + result.apiStatus);
	                    }
	                  });
	                }
	
	              case 8:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function resetPasswordClicked() {
	        return _ref.apply(this, arguments);
	      }
	
	      return resetPasswordClicked;
	    }()
	  }, {
	    key: "getPermissionType",
	    value: function getPermissionType() {
	
	      if (this.clickedData && this.clickedData.type) {
	        var appRoleIdList = this.clickedData.appRoleIdList;
	        var userType = this.clickedData.type;
	        if (userType === "C") {
	          return 3; //contact only user
	        }
	        if (appRoleIdList.includes(7) || appRoleIdList.includes(8) || appRoleIdList.includes(9) || appRoleIdList.includes(11) || appRoleIdList.includes(15)) {
	          return 2; //Role requires permissions
	        }
	
	        return 1; //Roles do NOT require permissions
	      }
	
	      return 0; //Show empty tab
	    }
	  }, {
	    key: "getUserPermissions",
	    value: function getUserPermissions() {
	      var _this5 = this;
	
	      if (this.getPermissionType() === 2) {
	
	        this.clientService.getUserPermissions(this.clickedData.userId, function (result) {
	          if (result.apiStatus === _apiStatus2.default.SUCCESS) {
	            _this5.userPermissionsDivision = result.divisionTierList;
	            _this5.userPermissionsProject = result.projectTierList;
	            _treeUtil2.default.uncheckAll(_this5.permissionsTreeIdDivision);
	            _treeUtil2.default.uncheckAll(_this5.permissionsTreeIdProject);
	
	            _treeUtil2.default.refreshTree(_this5.permissionsTreeIdDivision, _this5.userPermissionsDivision, false);
	            _treeUtil2.default.refreshTree(_this5.permissionsTreeIdProject, _this5.userPermissionsProject, false);
	
	            _this5.loadProjectAccessTable();
	            _this5.scope.$apply();
	          } else {
	            _dialogUtil2.default.showErrorMessage("Error getting user permissions: " + result.apiStatus);
	          }
	        });
	      }
	    }
	  }, {
	    key: "loadProjectAccessTable",
	    value: function loadProjectAccessTable() {
	      var _this6 = this;
	
	      var projectAccessData = [];
	      this.userPermissionsDivision.forEach(function (region) {
	        var regName = region.text;
	        region.children.forEach(function (division) {
	          var divName = division.text;
	
	          if (division.state) {
	            //is checked
	            //Get the projects for this division
	            _this6.userPermissionsProject.forEach(function (div) {
	              if (div.dbId === division.dbId) {
	                div.children.forEach(function (proj) {
	                  projectAccessData.push({ region: regName, division: divName, community: proj.text });
	                });
	              }
	            });
	          }
	        });
	      });
	
	      this.userPermissionsProject.forEach(function (division) {
	        var divName = division.text;
	        division.children.forEach(function (project) {
	          var projName = project.text;
	
	          if (project.state) {
	            //is checked
	            //Add to list if it does not exist already
	            var regName = _this6.getRegion(division.dbId);
	            if (!_this6.projectExists(projectAccessData, regName, divName, projName)) {
	              projectAccessData.push({ region: regName, division: divName, community: projName });
	            }
	          }
	        });
	      });
	
	      if (this.datatable) {
	        this.datatable.destroy();
	      }
	
	      this.datatable = _datatableUtil2.default.initializeTable('permission-project-access', this.PROJECT_ACCESS_COLUMNS, projectAccessData, { pagination: false, sortable: true });
	    }
	  }, {
	    key: "getRegion",
	    value: function getRegion(divId) {
	      var reg = "";
	
	      this.userPermissionsDivision.forEach(function (region) {
	        region.children.forEach(function (division) {
	          if (division.dbId === divId) {
	            reg = region.text;
	          }
	        });
	      });
	
	      return reg;
	    }
	  }, {
	    key: "projectExists",
	    value: function projectExists(projectAccessData, regName, divName, projName) {
	      var ret = false;
	      projectAccessData.forEach(function (data) {
	        if (data.division === divName && data.community === projName && data.region === regName) {
	          ret = true;
	        }
	      });
	
	      return ret;
	    }
	  }, {
	    key: "savePermissions",
	    value: function savePermissions() {
	      var _this7 = this;
	
	      var divisionIds = this.getSelectedNodesInTree(this.permissionsTreeIdDivision);
	      var projectIds = this.getSelectedNodesInTree(this.permissionsTreeIdProject);
	
	      if (divisionIds.length > 0 || projectIds.length > 0) {
	        var data = { userId: this.clickedData.userId, divisionIds: divisionIds, projectIds: projectIds };
	        this.clientService.updateUserPermissions(data, function (result) {
	          if (result.apiStatus === _apiStatus2.default.SUCCESS) {
	            _this7.getUserPermissions();
	            _dialogUtil2.default.showSuccessMessage("User permissions have been updated successfully!");
	          } else {
	            _dialogUtil2.default.showErrorMessage("Error updating user permissions: " + result.apiStatus);
	          }
	        });
	      } else {
	        _dialogUtil2.default.showErrorMessage("Please select at least one division or project for permission access");
	      }
	    }
	  }, {
	    key: "selectPressed",
	    value: function selectPressed() {
	      $('.btnCheckBox').prop('checked', this.selectAll);
	
	      this.selectAll = !this.selectAll;
	    }
	  }, {
	    key: "getSelectedNodesInTree",
	    value: function getSelectedNodesInTree(treeId) {
	      var nodeType = treeId === this.permissionsTreeIdDivision ? _nodeType2.default.DIVISION : _nodeType2.default.PROJECT;
	      var selectedNodes = _treeUtil2.default.getCheckedNodes(treeId);
	      var ids = [];
	      selectedNodes.forEach(function (node) {
	        if (node && node.nodeType === nodeType) {
	          ids.push(node.dbId);
	        }
	      });
	
	      return ids;
	    }
	  }]);
	  return UserController;
	}();
	
	exports.default = UserController;

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jstree = __webpack_require__(585);
	
	var _jstree2 = _interopRequireDefault(_jstree);
	
	var _jquery = __webpack_require__(485);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _angularUiRouter = __webpack_require__(335);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 */
	exports.initializeTree = function (id, data, options, callback) {
	  var treeInstance = (0, _jquery2.default)('#' + id).jstree({
	    "core": {
	      "themes": {
	        "responsive": false,
	        //"variant": "small",
	        "icons": false
	      },
	
	      "data": data
	    },
	    "types": {
	      "default": {
	        //"icon": "fa fa-folder text-warning"
	      },
	      "file": {
	        //"icon": "fa fa-file  text-warning"
	      }
	    },
	    "search": {
	      "case_insensitive": true,
	      "show_only_matches": (0, _angularUiRouter.isNullOrUndefined)(options.show_only_matches) ? false : options.show_only_matches,
	      "show_only_matches_children": true,
	      "search_callback": function search_callback(str, node) {
	        //search for any of the words entered
	        var word,
	            words = [];
	        var searchFor = str.toLowerCase().replace(/^\s+/g, '').replace(/\s+$/g, '');
	        if (searchFor.indexOf(' ') >= 0) {
	          words = searchFor.split(' ');
	        } else {
	          words = [searchFor];
	        }
	        for (var i = 0; i < words.length; i++) {
	          word = words[i];
	          var searchTerm = options.searchField == "status" ? node.original.status : node.text;
	          searchTerm = (0, _angularUiRouter.isNullOrUndefined)(searchTerm) ? "" : searchTerm;
	          if ((searchTerm || "").toLowerCase().indexOf(word) >= 0) {
	            return true;
	          }
	        }
	        return false;
	      }
	
	    },
	    "checkbox": {
	      "tie_selection": false
	    },
	    "plugins": (0, _angularUiRouter.isNullOrUndefined)(options.checkbox) ? ["wholerow", "types", "search", "cookies"] : ["state", "wholerow", "types", "checkbox"]
	  });
	
	  // handle link clicks in tree nodes(support target="_blank" as well)
	  var jsTreeId = "#" + id;
	
	  //If set to open all, always open all nodes on the tree when refreshed
	  if (!(0, _angularUiRouter.isNullOrUndefined)(options.open_all)) {
	    (0, _jquery2.default)(jsTreeId).bind("refresh.jstree", function (e, data) {
	      (0, _jquery2.default)(this).jstree("open_all");
	    });
	  }
	
	  var validNodeTypes = options.validNodeTypes;
	  (0, _jquery2.default)(jsTreeId).on('select_node.jstree', function (e, data) {
	    //console.log($(jsTreeId).jstree("get_selected"))
	    var node = (0, _jquery2.default)(jsTreeId).jstree(true).get_node(data.selected);
	    var selectedNode = node.original;
	    selectedNode.parent = data.instance.get_node(data.node.parent).text;
	
	    var shouldCallback = true;
	    if (validNodeTypes) {
	      if (validNodeTypes.includes(selectedNode.nodeType)) {
	        //Call the callback if first node selected or different node selected
	        shouldCallback = !data.instance.goodNode || data.instance.goodNode != node;
	        data.instance.goodNode = node; //save a valid node if selected so I can re-select if bad one is selected
	      } else {
	        shouldCallback = false;
	        //deselect the node and select the old node
	        data.instance.deselect_node(node);
	        if (data.instance.goodNode) {
	          data.instance.select_node(data.instance.goodNode);
	        }
	      }
	    }
	    if (callback && shouldCallback) {
	      callback(selectedNode, data);
	    }
	  });
	
	  (0, _jquery2.default)(jsTreeId).on('open_node.jstree', function (evt, data) {
	    data.instance.set_icon(data.node, 'http://jstree.com/tree-icon.png');
	    //console.log(data)
	    (0, _jquery2.default)(".jstree-icon.jstree-ocl").css("rotate: transform(90deg)");
	  }).on('close_node.jstree', function (evt, data) {
	    data.instance.set_icon(data.node, true);
	  });
	
	  // Initialize search
	  var to = false;
	  var jsTreeSearchId = jsTreeId + "-search";
	  (0, _jquery2.default)(jsTreeSearchId).keyup(function () {
	    if (to) {
	      clearTimeout(to);
	    }
	    to = setTimeout(function () {
	      var v = (0, _jquery2.default)(jsTreeSearchId).val();
	      (0, _jquery2.default)(jsTreeId).jstree(true).search(v);
	      //console.log($(jsTreeId).jstree(true));
	    }, 250);
	  });
	
	  return treeInstance;
	};
	
	exports.searchTree = function (treeId, searchQuery) {
	  var jsTreeId = "#" + treeId;
	  (0, _jquery2.default)(jsTreeId).jstree(true).search(searchQuery);
	};
	
	exports.refreshTree = function (treeId, newData, deselect_all) {
	  var jsTreeId = "#" + treeId;
	  if (deselect_all) (0, _jquery2.default)(jsTreeId).jstree(true).deselect_all(true);
	  (0, _jquery2.default)(jsTreeId).jstree(true).settings.core.data = newData;
	  (0, _jquery2.default)(jsTreeId).jstree(true).refresh(false, true);
	};
	
	exports.uncheckAll = function (treeId) {
	  var jsTreeId = "#" + treeId;
	  (0, _jquery2.default)(jsTreeId).jstree(true).uncheck_all(true);
	};
	
	exports.deselectAll = function (treeId) {
	  var jsTreeId = "#" + treeId;
	  (0, _jquery2.default)(jsTreeId).jstree(true).deselect_all(true);
	};
	
	exports.redrawTree = function (treeId, newData, deselect_all) {
	  var jsTreeId = "#" + treeId;
	  (0, _jquery2.default)(jsTreeId).on("ready.jstree", function () {
	    if (deselect_all) (0, _jquery2.default)(jsTreeId).jstree(true).deselect_all(true);
	    (0, _jquery2.default)(jsTreeId).jstree(true).settings.core.data = newData;
	    (0, _jquery2.default)(jsTreeId).jstree(true).redraw(true);
	  });
	};
	
	exports.getNodes = function (treeId, jsTreeMethod) {
	  var jsTreeId = "#" + treeId;
	  var selectedNodes = [];
	  (0, _jquery2.default)(jsTreeId).jstree(jsTreeMethod).forEach(function (node) {
	    var selectedNode = (0, _jquery2.default)(jsTreeId).jstree(true).get_node(node).original;
	    selectedNodes.push(selectedNode);
	  });
	  return selectedNodes;
	};
	
	exports.getCheckedNodes = function (treeId) {
	  return this.getNodes(treeId, "get_checked");
	};
	
	exports.checkTreeNodes = function (treeid, nodeids) {
	  var tree = (0, _jquery2.default)("#" + treeid);
	  // IE
	  tree.jstree(true).check_node(nodeids);
	  // Chrome or Firefox
	  tree.on("loaded.jstree", function (e, data) {
	    tree.jstree(true).check_node(nodeids);
	  }).jstree();
	};
	
	exports.selectedNode = function (treeId, nodeId) {
	  var instance = (0, _jquery2.default)("#" + treeId).jstree(true);
	  //m = instance._model.data;
	  // for(var i in m) {
	  //   console.log(m[i])
	  //   // if(m.hasOwnProperty(i) && i !== '#' && m[i].li_attr.name && m[i].li_attr.name === "asdf") {
	  //   //     instance.select_node(i);
	  //   //     break;
	  //   // }
	  // }
	};
	
	exports.getParentNode = function (treeId, node) {
	  var instance = (0, _jquery2.default)("#" + treeId).jstree(true);
	  //console.log(instance)
	  //m = instance._model.data;
	
	  // $('#' + treeId).on('activate_node.jstree', function(e, data) {
	  //   if(data.instance.is_leaf(data.node)) {
	  //     alert("Leaf: " + data.node.text);
	  //     alert("Parent: " +  data.instance.get_node(data.node.parent).text);
	  //   }
	  // });
	};

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

	'use strict';
	
	exports.initializeTable = function (tableId, columns, data, options) {
	    var pagination = options === undefined || options.pagination === undefined ? true : options.pagination;
	    var layout = options === undefined || options.layout === undefined ? {} : options.layout;
	    var sortable = options === undefined || options.sortable === undefined ? true : options.sortable;
	    var rowCallback = options === undefined || options.rowCallback === undefined ? true : options.rowCallback;
	
	    var table = $('#' + tableId).KTDatatable({
	        data: {
	            type: 'local',
	            source: data,
	            pageSize: 10
	        },
	        rows: {
	            autoHide: false,
	            beforeTemplate: rowCallback
	        },
	        columns: columns,
	        sortable: sortable,
	        pagination: pagination,
	        layout: layout,
	        search: {
	            input: $('#kt_datatable_search_query'),
	            key: 'generalSearch'
	        }
	    });
	
	    var addFunction = false;
	    columns.forEach(function (element) {
	        if (element.top) addFunction = true;
	    });
	    if (addFunction) {
	        $(table).on("datatable-on-layout-updated", function () {
	            var tableHead = $(this).find('thead');
	            var spans = $(tableHead).find('tr th span');
	
	            var i = void 0;
	            var myHeader = '<tr class="datatable-row" style="left:0;border-bottom:0">';
	            for (i = 0; i < spans.length; i++) {
	                var col = columns[i];
	                var num = 1;
	                var title = "";
	                if (col.top) {
	                    num = col.top.span;
	                    title = col.top.title;
	                }
	
	                var j = void 0;
	                var width = 0;
	                for (j = 0; j < num; j++) {
	                    width += $(spans.get(i + j)).outerWidth();
	                }
	
	                width += (num - 1) * 5;
	
	                i += num - 1;
	                myHeader += '<th class="datatable-cell" style="padding-bottom: 0;"><span style="overflow:hidden;width:' + width + 'px;">' + title + '</span></th>';
	            }
	
	            myHeader += '</tr>';
	            tableHead.prepend(myHeader);
	        });
	    }
	
	    return table;
	};

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _freeze = __webpack_require__(445);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = (0, _freeze2.default)({
	    COMPANY: 1,
	    PROJECT: 2,
	    FUND: 3,
	    FUND_SUBSIDIARY: 4,
	    DIVISION: 5,
	    BUILDER: 6,
	    USER: 7,
	    LOT_TYPE: 8,
	    LOT: 9,
	    PHASE: 10,
	    TAKEDOWN: 11,
	    TAKEDOWN_STATUS: 12,
	    REGION: 13,
	    BANK: 14,
	    BANK_ACCOUNT: 15
	});

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(589);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(457)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./user.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./user.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(456)();
	// imports
	
	
	// module
	exports.push([module.id, "#userPage #rightColumn .scroll{max-height:500px;overflow:auto;padding-right:10px}#userPage #userContainer{max-height:600px;overflow:auto;padding-right:10px;margin-top:10px}#userPage #leftColumn{width:40%;max-width:500px;padding-right:50px}#userPage #rightColumn{width:60%;max-width:800px}#userPage .boldTitle{font-weight:700;margin:5px 0}#userPage .userRow{padding:3px;font-size:1.1rem}#userPage .userRow:hover{background:#d3d3d3;font-weight:700}#userPage .profileImage{font-family:courier;border-radius:50%;border:1px solid #000;font-size:12px;color:#000;text-align:center;line-height:24px;padding:5px;margin-top:5px}#userPage #inactive{margin-left:20px}#userPage .radioGroup label{margin-left:5px}#userPage .form-group{margin-bottom:1rem}#userPage .card-header{border-bottom:0}#userPage #permission-project-access .datatable-table,#userPage #permissions-tree-division,#userPage #permissions-tree-project{height:300px}#resetPasswordForm{padding:10px 50px}#userPage .datatable-cell span{width:200px!important}.swal2-content:has(#resetPswdPopup){height:180px}#rpe{color:red}", ""]);
	
	// exports


/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(591);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default
	};
	
	exports.default = appComponent;

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

	module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\">\n  <div ui-view></div>\n</div>\n"

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(593);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(457)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(456)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%;font:62.5% Roboto,sans-serif}.filter-option *{color:#464e5f}.subheader{color:#041e47;justify-content:center;font-size:14pt}@media (min-width:1400px){.container,.container-lg,.container-md,.container-sm,.container-xl,.container-xxl{max-width:1800px}}.form-control.form-control-solid{border:1px solid #d3d3d3}.swal2-styled.swal2-confirm{background-color:#041e47}.swal2-styled.swal2-confirm:hover{background-color:#037fff}input[type=checkbox]{transform:scale(1.5)}.lblue,.lblue-anchor{color:#315299;font-weight:700}.lblue-anchor{text-decoration:underline;cursor:help}.userDetailPopup td{padding:5px}.userDetailPopup td:first-child{text-align:right;font-weight:700}.userDetailPopup td:last-child{text-align:left}.red{color:red}.app{height:100vh}#kt_content,.app,.header-mobile,body{background-color:#fff}.bg-primary{background-color:#041e47!important}.row{color:#041e47}.mycustomheader{color:#21618c;font-size:.9rem;text-transform:uppercase;font-weight:600;letter-spacing:.1rem;white-space:nowrap;overflow:hidden}#overlay{display:none;background:hsla(0,0%,100%,.7);position:fixed;bottom:0;left:0;right:0;top:0;z-index:9998;align-items:center;justify-content:center}.show-spinner{display:flex}.hide-spinner{display:none}.aside{background-color:#fff;padding-left:10px;margin-top:45px;z-index:1!important;padding-top:5px}.jstree-default .jstree-node{min-height:24px;line-height:24px;margin-left:6px;min-width:24px}.datatable.datatable-default>.datatable-table>.datatable-body .datatable-row>.datatable-cell,.datatable.datatable-default>.datatable-table>.datatable-foot .datatable-row>.datatable-cell,.datatable.datatable-default>.datatable-table>.datatable-head .datatable-row>.datatable-cell{padding:.3rem .2rem}.datatable-body .datatable-row:hover{background-color:#d3d3d3}.datatable.datatable-default.datatable-head-custom>.datatable-table>.datatable-foot .datatable-row>.datatable-cell.datatable-cell-sorted>span,.datatable.datatable-default.datatable-head-custom>.datatable-table>.datatable-foot .datatable-row>.datatable-cell>span,.datatable.datatable-default.datatable-head-custom>.datatable-table>.datatable-head .datatable-row>.datatable-cell.datatable-cell-sorted>span,.datatable.datatable-default.datatable-head-custom>.datatable-table>.datatable-head .datatable-row>.datatable-cell>span,.datatable.datatable-default>.datatable-table>.datatable-head .datatable-row>.datatable-cell>span>i{color:#21618c}.card.card-custom{box-shadow:10px 10px 10px 10px rgba(82,63,105,.05);border:1px solid #e5eaee}.datatable .btn-sm{padding:.15rem .75rem;font-size:.925rem;line-height:1.35;border-radius:.42rem}th,th span{text-align:center!important;vertical-align:bottom!important}.datatable-body td span,.report-header{text-align:center}.report-header{font-weight:700;margin-bottom:5px;color:#041e47}.border tbody tr:last-child,.summary-highlight{border-top:1px solid;background:#e5eaee}.highlight{background:#beebff;border-radius:3px}textarea{overflow:auto;outline:none;box-shadow:none}.initialMessage{text-align:center;line-height:200px;font-size:12pt}.datatable-table,.jstree{overflow:auto!important}.tdInfoTable{width:100%;font-weight:700}.tdInfoTable tr td{padding:2px 5px}.jstree-default .jstree-anchor{padding:0}.jstree-children{padding-left:5px}.ta-r{text-align:right}li.jstree-node.needsAttention{font-weight:700}.tablePopup{width:100%}.tablePopup tr:first-child{border-bottom:1px solid #ecf0f3}.tablePopup tr:hover{background-color:#d3d3d3}.tablePopup tr:first-child{font-size:.9rem;text-transform:uppercase;font-weight:600;letter-spacing:.1rem;color:#21618c;vertical-align:bottom}.tablePopup td{padding:.3rem;padding-right:2rem}", ""]);
	
	// exports


/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _network = __webpack_require__(595);
	
	var _network2 = _interopRequireDefault(_network);
	
	var _client = __webpack_require__(638);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _auth = __webpack_require__(639);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _spinner = __webpack_require__(640);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Adding all services to an angular module and exporting them
	var servicesModule = angular.module('services', []).service('NetworkService', _network2.default).service('ClientService', _client2.default).service('AuthService', _auth2.default).service('SpinnerService', _spinner2.default).name;
	
	exports.default = servicesModule;

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(421);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _regenerator = __webpack_require__(523);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(526);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(425);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _urlPaths = __webpack_require__(596);
	
	var _urlPaths2 = _interopRequireDefault(_urlPaths);
	
	var _apiStatus = __webpack_require__(471);
	
	var _apiStatus2 = _interopRequireDefault(_apiStatus);
	
	var _http = __webpack_require__(597);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _https = __webpack_require__(637);
	
	var _https2 = _interopRequireDefault(_https);
	
	var _dialogUtil = __webpack_require__(468);
	
	var _dialogUtil2 = _interopRequireDefault(_dialogUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NetworkService = function () {
	  NetworkService.$inject = ["SpinnerService", "$rootScope", "$state"];
	  function NetworkService(SpinnerService, $rootScope, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, NetworkService);
	    this.$state = $state;
	    this.$scope = $rootScope;
	    this.spinnerService = SpinnerService;
	  }
	
	  /**
	   * getOptions: Create options header for http request
	   * @param {String} httpRequestType method in http header
	   * @param {String} apiUrl api url path
	   */
	
	  (0, _createClass3.default)(NetworkService, [{
	    key: 'getOptions',
	    value: function getOptions(httpRequestType, apiUrl) {
	
	      return {
	        withCredentials: true,
	        host: _urlPaths2.default.HOST,
	        port: _urlPaths2.default.PORT,
	        path: _urlPaths2.default.PATH + apiUrl,
	        method: httpRequestType,
	        headers: {
	          'Content-Type': 'application/json'
	        }
	      };
	    }
	  }, {
	    key: 'makeHTTPRequest',
	    value: function makeHTTPRequest(options, data, onResult) {
	      var _this = this;
	
	      this.spinnerService.showSpinner();
	      var port = options.port === 443 ? _https2.default : _http2.default;
	      var req = port.request(options, function () {
	        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(res) {
	          var output;
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  output = '';
	
	                  res.setEncoding('utf8');
	                  res.on('data', function (chunk) {
	                    output += chunk;
	                  });
	                  res.on('end', function () {
	                    if (res.statusCode === 200) {
	                      if (res.headers["content-type"] === "application/json") {
	                        var obj = JSON.parse(output);
	                        if (obj.apiStatus === _apiStatus2.default.INVALID_SESSION) {
	                          _this.$state.go("auth.login");
	                        } else if (obj.apiStatus === _apiStatus2.default.UNAUTHORIZED) {
	                          _this.$state.go("main.home");
	                        } else if (obj.apiStatus === _apiStatus2.default.ALREADY_EXISTS) {
	                          _dialogUtil2.default.showErrorMessage("Entry already exists. Please try again.");
	                        } else {
	                          onResult(obj);
	                        }
	                      } else {
	                        // Download file
	                        _this.downloadFile(res, output);
	                      }
	                    } else {
	                      _dialogUtil2.default.showErrorMessage("Call to server failed with " + res.statusCode);
	                    }
	                    _this.spinnerService.hideSpinner();
	                  });
	
	                case 4:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	
	      if (data !== null) {
	        req.write((0, _stringify2.default)(data));
	      }
	
	      var parent = this;
	      req.on('error', function (err) {
	        console.log('error: ' + err.message);
	        _dialogUtil2.default.showErrorMessage("Call to server failed.");
	        parent.spinnerService.hideSpinner();
	      });
	
	      req.end();
	    }
	
	    /**
	     * execute: Execute any http request
	     * @param {string} httpRequestType method in http header
	     * @param {string} apiUrl api url path
	     * @param {Object} data data to be posted
	     * @param callback callback function to handle response
	     */
	
	  }, {
	    key: 'execute',
	    value: function execute(httpRequestType, apiUrl, data, callback) {
	      var options = this.getOptions(httpRequestType, apiUrl);
	      return this.makeHTTPRequest(options, data, callback);
	    }
	  }, {
	    key: 'downloadFile',
	    value: function downloadFile(response, data) {
	      var octetStreamMime = 'application/octet-stream';
	
	      //get the headers' content disposition
	      // let cd = response.headers["content-disposition"];
	      //
	      // //get the file name with regex
	      // let regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
	      // let match = regex.exec(cd);
	
	      //is there a fiel name?
	      var fileName = "myDefaultFileName.pdf";
	
	      //replace leading and trailing slashes that C# added to your file name
	      fileName = fileName.replace(/\"/g, "");
	
	      //determine the content type from the header or default to octect stream
	      var contentType = response.headers["content-type"] || octetStreamMime;
	
	      //finally, download it
	      try {
	        var blob = new Blob([data], { type: contentType });
	
	        //downloading the file depends on the browser
	        //IE handles it differently than chrome/webkit
	        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	          window.navigator.msSaveOrOpenBlob(blob, fileName);
	        } else {
	          var objectUrl = URL.createObjectURL(blob);
	          window.open(objectUrl);
	        }
	      } catch (exc) {
	        console.log(exc);
	      }
	    }
	  }]);
	  return NetworkService;
	}();
	
	exports.default = NetworkService;

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _freeze = __webpack_require__(445);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants used in the controllers
	var urlRoutes = {};
	
	//Test and Prod
	urlRoutes.HOST = '';
	urlRoutes.PORT = '';
	urlRoutes.PATH = '/rest';
	
	// If localhost, talk to the dev environment
	if (window.location.hostname === 'localhost') {
	  urlRoutes.HOST = 'testportal.homesiteselections.com';
	  urlRoutes.PORT = 443;
	}
	
	module.exports = (0, _freeze2.default)(urlRoutes);

/***/ }),

/***/ 615:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 617:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(425);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClientService = function () {
	  ClientService.$inject = ["NetworkService"];
	  function ClientService(NetworkService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ClientService);
	    this.networkService = NetworkService;
	  }
	
	  (0, _createClass3.default)(ClientService, [{
	    key: 'getAllUsersApplicationsRoles',
	    value: function getAllUsersApplicationsRoles(callback) {
	      this.networkService.execute('GET', '/users/applications/roles', null, callback);
	    }
	  }, {
	    key: 'getAllApplicationsRoles',
	    value: function getAllApplicationsRoles(callback) {
	      this.networkService.execute('GET', '/applications/roles', null, callback);
	    }
	  }, {
	    key: 'updateUser',
	    value: function updateUser(id, data, callback) {
	      this.networkService.execute('POST', '/user', { id: id, data: data }, callback);
	    }
	  }, {
	    key: 'getUserPermissions',
	    value: function getUserPermissions(userId, callback) {
	      this.networkService.execute("GET", '/user/permission?id=' + userId, null, callback);
	    }
	  }, {
	    key: 'updateUserPermissions',
	    value: function updateUserPermissions(data, callback) {
	      this.networkService.execute("PUT", '/user/permission', data, callback);
	    }
	  }]);
	  return ClientService;
	}();
	
	exports.default = ClientService;

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(421);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(425);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _apiStatus = __webpack_require__(471);
	
	var _apiStatus2 = _interopRequireDefault(_apiStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthService = function () {
	  AuthService.$inject = ["NetworkService", "$state"];
	  function AuthService(NetworkService, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AuthService);
	    this.state = $state;
	    this.networkService = NetworkService;
	  }
	
	  (0, _createClass3.default)(AuthService, [{
	    key: 'getSessionInfo',
	    value: function getSessionInfo(callback) {
	      this.networkService.execute('GET', '/common/user/session', null, function (result) {
	        //alert(JSON.stringify(result))
	        if (result.apiStatus === _apiStatus2.default.SUCCESS) {
	          if (result.data.redirectUrl) {
	            window.location = result.data.redirectUrl;
	          } else {
	            //set the userdata in session so I can access later
	            sessionStorage.setItem('userData', (0, _stringify2.default)(result.data));
	          }
	        }
	        callback(result);
	      });
	    }
	  }, {
	    key: 'getUserRoles',
	    value: function getUserRoles() {
	      var userData = JSON.parse(sessionStorage.getItem('userData'));
	      return userData ? userData.roleIdList : [];
	    }
	  }, {
	    key: 'getAppAccess',
	    value: function getAppAccess() {
	      var userData = JSON.parse(sessionStorage.getItem('userData'));
	      return userData ? userData.applicationList : [];
	    }
	  }, {
	    key: 'getUserFirstName',
	    value: function getUserFirstName() {
	      var userData = JSON.parse(sessionStorage.getItem('userData'));
	      return userData && userData.firstName ? userData.firstName : " ";
	    }
	  }, {
	    key: 'checkAuthenticated',
	    value: function checkAuthenticated(callback) {
	      var userData = sessionStorage.getItem('userData');
	
	      if (!userData) {
	        //I don't have user data now (might be a new tab)
	        //although the session cookie may still be valid
	        //So try to get session data from the session cookie
	        //If the session cookie is not valid, this call will redirect to login
	        this.getSessionInfo(function () {
	          //only need to call the callback function.  This callback will only be called if the session is valid
	          callback();
	        });
	      }
	
	      //authenticated if user data is not null, although session might be invalid
	      //The next call to the server will return INVALID_SESSION and redirect to login
	      return userData !== null;
	    }
	  }, {
	    key: 'hasUserRole',
	    value: function hasUserRole(requiredRoleId) {
	      var userRoles = this.getUserRoles();
	      if (!userRoles) {
	        return false;
	      }
	      return userRoles.find(function (x) {
	        return x === requiredRoleId;
	      }) !== undefined;
	    }
	  }, {
	    key: 'login',
	    value: function login(username, password, callback) {
	      var data = { username: username, password: password };
	      this.networkService.execute('POST', '/login', data, callback);
	    }
	  }, {
	    key: 'forgotPassword',
	    value: function forgotPassword(emailId, callback) {
	      var data = { emailId: emailId };
	      this.networkService.execute('POST', '/forgot/password', data, callback);
	    }
	
	    //Common functions below
	
	  }, {
	    key: 'getUserProfile',
	    value: function getUserProfile(callback) {
	      this.networkService.execute('GET', '/common/user/profile', null, callback);
	    }
	  }, {
	    key: 'updateUserProfile',
	    value: function updateUserProfile(profile, callback) {
	      this.networkService.execute('PUT', '/common/user/profile', profile, callback);
	    }
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword(token, password, callback) {
	      var data = { password: password, token: token };
	      this.networkService.execute('PUT', '/common/password', data, callback);
	    }
	  }, {
	    key: 'resetPasswordForUser',
	    value: function resetPasswordForUser(userId, password, callback) {
	      var data = { id: userId, password: password };
	      this.networkService.execute('PUT', '/common/password', data, callback);
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      var _this = this;
	
	      this.networkService.execute('DELETE', '/common/login', {}, function () {
	        sessionStorage.clear();
	        _this.state.go("auth.login");
	      });
	    }
	  }]);
	  return AuthService;
	}();
	
	exports.default = AuthService;

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(425);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jquery = __webpack_require__(485);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SpinnerService = function () {
	    function SpinnerService() {
	        (0, _classCallCheck3.default)(this, SpinnerService);
	
	        this.spinner = (0, _jquery2.default)("#overlay");
	    }
	
	    (0, _createClass3.default)(SpinnerService, [{
	        key: "showSpinner",
	        value: function showSpinner() {
	            this.spinner.css("display", "flex");
	        }
	    }, {
	        key: "hideSpinner",
	        value: function hideSpinner() {
	            this.spinner.css("display", "none");
	        }
	    }]);
	    return SpinnerService;
	}();
	
	exports.default = SpinnerService;

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = ["$transitions", "$state", "AuthService", function ($transitions, $state, AuthService) {
	  "ngInject";
	
	  $transitions.onBefore({}, function (transition) {
	    //console.log(transition.to())
	
	    // check if the state should be protected
	    var targetPageData = transition.to().data;
	    var transName = transition.to().name;
	    var state = $state;
	
	    if (targetPageData && targetPageData.protected) {
	      var authenticated = AuthService.checkAuthenticated(function () {
	        //If not authenticated, return false at first
	        //If session cookie is valid, I will get back here and
	        //can retry going to the transition
	        //If session cookie is not valid, the auth service will redirect to login
	        state.go(transName);
	      });
	
	      if (!authenticated) {
	        return false;
	      }
	    }
	
	    return true;
	  });
	
	  $transitions.onSuccess({}, function (transition) {
	    var topMenu = transition.to().data ? transition.to().data.topMenu : null;
	
	    $('navbar span').removeClass("navHighlight");
	    if (topMenu) {
	      setTimeout(function () {
	        $("navbar span:contains('" + topMenu + "')").first().addClass("navHighlight");
	      }, 200);
	    }
	
	    //scroll back to the top after transition...is there a better way to do this?
	    setTimeout(function () {
	      window.scrollTo(0, 0);
	    }, 200);
	
	    return true;
	  });
	}];

/***/ })

});


// WEBPACK FOOTER //
// app.bundle.js